/* eslint-disable react/no-unescaped-entities */

import { Fragment } from 'react';

import { capitalize } from 'lodash';
import { Dictionary, DICTIONARY_LINKS } from '../types';

export const dictionary: Dictionary = {
  certification: 'Certification',
  since: 'sinds',
  notAvailableAnymore: 'Niet langer beschikbaar',
  workingHours: 'Werkuren',
  commuteDistance: 'Reisafstand',
  relocation: 'Verhuizing',
  salary: 'Salaris',
  preferredJobs: 'Voorkeursfuncties',
  total: 'Totaal',
  copyText: 'Kopieer tekst',
  copy: 'Kopieer',
  unableToRefresh: 'Kan niet vernieuwen',
  current: 'Huidige',
  past: 'Vorige',
  today: 'Vandaag',
  syncing: 'Synchroniseren...',
  syncingSuccessfully: 'Synchronisatie succesvol!',
  syncingFailed: 'Synchronisatie mislukt!',
  noDataAvailable: 'Geen informatie beschikbaar',
  cvAvailable: 'CV Beschikbaar',
  hours: 'Uur',

  login: 'Log In',
  rememberMe: 'Onthoud Mij',
  logout: 'Uitloggen',
  registerAccount: 'Maak een account',
  newCompany: 'Nieuw Bedrijf',
  required: 'Verplicht',
  notRequired: 'Niet verplicht',
  questionnaireMustHave: 'Moet',
  questionnaireNiceToHave: 'Mag',
  questionnaireDoesntMatch: 'Komt niet overeen',
  questionnaireCandidateColumn: 'Kandidaat',
  questionnaireRequirementColumn: 'Vereiste',
  questionnaireMustHaveTooltip: (
    <>
      Definieert een essentiële vereiste voor de functie.
      <br />
      Andere vragen geven extra context.
    </>
  ),
  showPassword: 'Laat wachtwoord zien',
  hidePassword: 'Verberg wachtwoord',
  forgotPassword: 'Wachtwoord vergeten?',
  forgotYourPassword: 'Wachtwoord vergeten?',
  forgotPasswordDescription:
    'Er wordt een link voor het opnieuw instellen van uw wachtwoord naar uw e-mailadres verzonden om uw wachtwoord opnieuw in te stellen. Als u binnen een paar minuten geen e-mail ontvangt, probeert u het opnieuw.',
  resetPassword: 'Reset Wachtwoord',
  multiFactorAuth: 'Verificatiecode',
  enterMultiFactorAuthCode: 'Vul de verificatiecode in die naar je e-mailadres verstuurd is',
  resetPasswordMailSentDescription:
    'Een link voor het opnieuw instellen van uw wachtwoord verzonden naar uw e-mailadres. Controleer alstublieft uw e-mails.',
  mailSent: 'Mail verstuurd',
  pleaseEnterYourNewPassword: 'Voer uw nieuwe wachtwoord in.',
  preferences: 'Voorkeuren',
  email: 'Email',
  emailNotifications: 'E-mail notificaties',
  sendEmail: 'Verstuur Email',
  username: 'Gebruikersnaam',
  userName: 'Gebruikersnaam',
  password: 'Wachtwoord',
  passwordRepeat: 'Wachtwoord (herhaald)',
  overview: 'Overzicht',
  new: 'Nieuw',
  viewAll: 'Bekijk alles',
  statistics: 'Statistieken',
  comingSoon: 'Komt snel',
  administration: 'Administratie',
  connections: 'Koppelingen',
  availableCredits: (left, total, isPayPerMatch = false) => (
    <Fragment>
      {isPayPerMatch ? 'Matches' : 'Nog'} <b>{left}</b>/{total} {isPayPerMatch ? 'beschikbaar' : 'tegoed'}
    </Fragment>
  ),
  cv: 'CV',
  profile: 'Profiel',
  emailAddress: 'Email adres',
  emailAddressForTeams: 'Team e-mailadres',
  phoneNumber: 'Telefoonnummer',
  nickname: 'Bijnaam',
  companyName: 'Bedrijfsnaam',
  companiesWorkedAt: 'Werkervaring bij bedrijven',
  companiesWorkedAtPlaceholder: 'Bijvoorbeeld Rabobank',
  companySize: 'Bedrijfsgrootte',
  companyType: 'Type bedrijf',
  selectCountry: 'Land',
  selectATS: 'Selecteer jouw ATS',
  whatATSAreYouUsing: 'Welk ATS gebruik je?',
  howDidYouHearAboutUs: 'Hoe heb je over ons gehoord?',
  pleaseExplain: 'Geef toelichting...',
  save: 'Opslaan',
  next: 'Volgende',
  previous: 'Vorige',
  submit: 'Aanmaken',
  back: 'Terug',
  cancel: 'Annuleren',
  browserExtension: 'Browser extensie',
  robinExtension: 'Robin extensie',
  changePassword: 'Wijzig wachtwoord',
  currentPassword: 'Huidig wachtwoord',
  newPassword: 'Nieuw wachtwoord',
  repeatNewPassword: 'Nieuw wachtwoord (herhalen)',
  chooseFile: 'Selecteer bestand',
  noFileChosen: 'Geen bestand geselecteerd',
  roles: 'Functies',
  users: 'Gebruikers',
  user: 'Gebruiker',
  ats: 'ATS',
  atsCompleteName: 'Applicant tracking system',
  addedToAts: 'toegevoegd tot ATS',
  jobBoards: 'Jobsites',
  useRolesToGroupPermissions: 'Gebruik rollen om machtigingen te groeperen.',
  manageUsersAndPermissions: 'Beheer gebruikers en rechten.',
  recruitmentAgency: 'Wervingsbureau',
  corporate: 'Corporate',
  freelancer: 'Freelancer',
  selectInHouseRecruiters: 'Aantal inhouse recruiters',
  cantBeLessThanZeroRecruiters: 'Je kan niet minder dan 0 recruiters hebben',
  thisFieldIsRequired: 'Dit is een verplicht veld.',
  validationRequiredEmail: 'Vul hier een geldig e-mailadres in.',
  useYourWorkEmailAddress: 'Vul een werk e-mailadres in.',
  validationPasswordConfirm: 'Vul hier dezelfde waarde in.',
  editCriteriaForMoreResults: 'Wijzig criteria voor meer resultaten',
  newResultsInHours: (hours) => <Fragment>Nieuwe resultaten over {hours} uur</Fragment>,
  newResultsOnMonday: 'Nieuwe resultaten op maandag',
  thereAreNewResults: (newResults) => `${newResults} nieuwe`,
  untitledSearch: 'Naam zoekopdracht',
  newSearch: 'Nieuwe zoekopdracht',
  searches: 'Zoekopdrachten',
  candidates: 'Kandidaten',
  teamview: 'Van team',
  teamView: 'Van Team',
  status: 'Status',
  lastAdded: 'Laatst toegevoegd',
  coWorker: 'Collega',
  search: 'Zoeken',
  sortBy: 'Sorteer op',
  sortedBy: 'Gesorteerd op',
  mySearches: 'Mijn zoekopdrachten',
  teamSearches: 'Zoekopdrachten team',
  allSearches: 'Alle zoekopdrachten',
  allShortlisted: 'Alle shortlisted',
  allContacted: 'Alle gecontacteerd',
  allHidden: 'Alle verborgen',
  allMatched: 'Alle matched',
  searchOverview: 'Overzicht zoekopdrachten',
  campaignNotificationByEmail: 'Email notificaties zoekopdrachten',
  campaignNotificationDisabled: 'Uitgeschakeld',
  campaignNotificationOnce: 'Een keer per dag (om 08:00)',
  campaignNotificationTwice: 'Twee keer per dag (om 08:00 en 16:00)',
  campaignNotificationThrice: 'Drie keer per dag (om 08:00, 12:00 en 16:00)',
  sendToNotificationTitle: 'Waar zullen we e-mails over nieuwe/gewijzigde kandidaten naartoe sturen?',
  sendToNotificationPersonal: 'Alleen persoonlijke e-mails',
  sendToNotificationTeam: 'Alleen team e-mails',
  sendToNotificationBoth: 'Zowel team als persoonlijke e-mails',
  askBeforeSpendingMonsterInventoryCredit: 'Toestemming vragen voordat je een Monster credit uitgeeft?',
  /// TODO WERKZOEKEN: Remove this after release new jobboard
  // askBeforeSpendingWerkzoekenCredit: 'Toestemming vragen voordat je een Werkzoeken credit uitgeeft?',
  yesAskEveryTime: 'Ja, altijd vragen',
  noNeverAsk: 'Nee, vraag nooit meer',
  adminPanel: 'Admin panel',
  intakePlanned: 'Matched',
  downloadAllApprovedCandidates: 'Download alle goedgekeurde kandidaten',
  downloadAllAMatched: 'Download alle gematchte',
  maxOf300CandidatesWillBeDownloaded: 'Er worden maximaal 300 kandidaten gedownload',
  searchForAts: 'Zoek een ATS-vacature',

  yes: 'Ja',
  no: 'Nee',
  areYouSure: 'Weet je het zeker?',
  confirmDeleteCampaign: 'Weet je zeker dat je deze campagne wilt verwijderen?',
  by: 'door',
  you: 'jou',
  in: 'in',
  here: 'hier',

  match: 'Match',
  shortlistCandidateToOtherSearch: 'Shortlist voor andere zoekopdracht',
  shortlistCandidateNameToOtherSearch: (name) => `Shortlist kandidaat ${name} voor andere zoekopdracht`,
  shortlistCandidateToOtherSearchDescription:
    'Shortlist kandidaat voor andere zoekopdracht & laat in de resultaten van huidige zoekopdracht',

  matched: 'Matched',
  hidden: 'Verborgen',
  shortlist: 'Shortlist',
  shortlisted: 'Shortlisted',
  unsaved: 'Unsaved',
  saved: 'Saved',
  connectToAts: 'Koppel met ATS',
  connectToAtsVacancy: 'Koppel vacature uit het ATS',
  unlocked: 'Ontgrendeld',
  downloadProfiles: 'Download Profielen',
  history: 'Kandidaat geschiedenis',
  activity: 'Activiteit',
  profileHistoryPlaceholder:
    'Geschiedenis informatie is hier zichtbaar als je actie onderneemt voor deze kandidaat zoals goedkeuren of afkeuren',
  details: 'Details',
  educationLevel: 'Opleidings Niveau (hoog/laag)',
  employer: 'Werkgever (a/z)',
  travelDistance: 'Reisafstand',
  availability: 'Beschikbaarheid',
  contactInfo: 'Te contacten via',
  Monsterboard: 'Monsterboard',
  Nationalevacaturebank: 'Nationale Vacature Bank',
  Werknl: 'Werk.nl',
  version: 'Versie',
  seeResults: 'Bekijk resultaten',
  notAbleDeleteSearchAts: 'Je kan geen aan je ATS gekoppelde zoekopdracht verwijderen',

  iAlreadyKnow: 'Ken ik al',
  overqualified: 'Te Zwaar',
  underqualified: 'Te Licht',
  wrongIndustry: 'Verkeerde Industrie',
  wrongEducation: 'Verkeerde Opleiding',
  wrongExperience: 'Verkeerde Ervaring',
  tooFarAway: 'Woont te ver weg',
  otherReasonNamely: 'Anders, namelijk...',
  other: 'Anders',
  hide: 'Verberg',
  check: 'Bekijken',

  contact: 'Contact',
  contacted: 'Gecontacteerd',
  calendarInterviewInvitationSent: 'Uitnodiging verzonden, wacht op kandidaat',
  calendarInterviewInvitationAccepted: 'Interview gepland',
  calendarInterviewInvitationRescheduled: 'Interview verplaatst',
  calendarInterviewInvitationRejected: 'Interviewuitnodiging afgewezen',
  calendarBookingStart: 'Start',
  calendarBookingDurationMinutes: (minutes: number) => `Duur: ${minutes} min`,
  positiveResponse: 'Positieve reactie',
  negativeResponse: 'Negatieve reactie',
  noResponse: 'Geen antwoord',
  searching: 'Zoeken',
  sentToAts: 'Verzonden naar ATS',
  sentToYourAts: 'Verzonden naar jouw ATS',
  jobTitleAndLabel: (jobTitle: string, label: string) => `${jobTitle} en ${label}`,
  interviewScheduled: 'Interview gepland',
  interviewBookedToastTitle: 'Gesprek ingepland',
  interviewBookedToastMessage: (name: string) => `${name} geeft de bevestiging ontvangen`,
  interviewPlaneed: 'Interview gepland',
  interviewCompleted: 'Interview afgerond',
  interviewCancelled: 'Interview afgezegd',
  leftVoicemail: 'Voicemail ingesproken',
  openToWorkNotInterested: 'Beschikbaar, niet geïnteresseerd',
  notOpenToWork: 'Niet (meer) beschikbaar',
  noResponsiveToReachout: 'Reageert niet',
  aiLanguageSelector: {
    tooltip: 'Verander de taal van de AI-gegenereerde berichten',
    auto: 'Auto (op basis van kandidaatinfo)',
    english: 'Engels',
    dutch: 'Nederlands',
  },
  translatingMessage: 'Bericht wordt vertaald...',
  selectTheLanguageOfTheMessage: 'Selecteer de taal van het bericht',
  default: 'Standaard',
  experience: 'Ervaring',
  education: 'Opleiding',
  courses: 'Cursussen',
  messageTranslatedSuccessfully: 'Bericht succesvol vertaald',
  certifications: 'Certificaten',
  reference: 'Referentie',
  skill: 'Vaardigheden',
  skills: 'Vaardigheden',
  language: 'Taal',
  languages: 'Talen',
  volunteerWork: 'Vrijwilligerswerk',
  industry: 'Industrie',
  company: 'Bedrijf',
  date: 'Datum',

  whyRejected: 'Waarom Afgekeurd?',
  whatIsTheStatus: 'Wat is de Status?',
  updateStatus: 'Status bijwerken',

  explanation: 'Toelichting',
  nameSearch: 'Naam voor de zoekopdracht',
  vacancy: 'Vacature',
  vacancyPlaceholder: 'Bijv. https://careers.recruitrobin.com/account-manager',
  jobTitle: 'Functietitel',
  jobTitles: 'Functietitels',
  jobTitlesTooltip: (
    <span>
      Een * kun je aan het begin en/of het einde van een woord zetten om naar meerdere varianten te zoeken.
      Bijvoorbeeld:
      <ul>
        <li>*Operator vindt resultaten als "Forklift Operator" en "Productie Operator"</li>
        <li>Logistiek* vindt resultaten als "Logistiek Supervisor" en "Logistiek Medewerker"</li>
        <li>*Warehouse* vindt resultaten als "Warehouse Employee" en "Supervisor Warehouse"</li>
      </ul>
    </span>
  ),
  addSuggestions: (number: number) => `Voeg ${number} suggesties toe`,
  jobTitlePlaceholder: 'Bijvoorbeeld Monteur',
  addJobTitlePlaceholder: 'Functietitel toevoegen',
  jobTitleWarning: 'Met slechts één functie zal waarschijnlijk genereren zeer weinig resultaten.',
  workExperience: 'Werkervaring in jaren',
  minWorkExperienceInYears: 'Min. Werkervaring in jaren',
  maxWorkExperienceInYears: 'Max. Werkervaring in jaren',
  minWorkExperienceInFunction: 'Min. Werkervaring in functie',
  screeningCriteria: 'Screening criteria',
  screeningCriteriaPlaceholder: '',
  country: 'Land',
  postalCode: 'Postcode',
  rangeInKm: 'Afstand in KM',
  startSearch: 'Start Zoekopdracht',
  editSearch: 'Bewerk Zoekopdracht',
  eg: 'Bijv.',
  errorDuplicatedJobTitle: 'Functietitel bestaat al. Voer een unieke functietitel in',

  veryWell: 'Erg goed!',
  iWillStartLookingForCandidates: (campaignName) => (
    <Fragment>
      Ik ga op zoek naar kandidaten voor je jobaanbieding <span>{campaignName}</span>
    </Fragment>
  ),
  whatToExpect: 'Wat te verwachten',
  whatToExpect1: 'Binnen 4 tot 24 uur een overzicht van potentiële kandidaten',
  whatToExpect2: 'Ik zal je tijdens de komende fases via e-mail op de hoogte houden.',
  editThisCampaign: 'Bewerk deze campagne',
  viewCampaigns: 'Bekijk campagnes',
  searchForCampaign: 'Zoek naar Campagne',
  ratioOfApprovedCandidates: (approved: number, total: number) => (
    <Fragment>
      <strong>{approved}</strong> van <strong>{total}</strong> matched
    </Fragment>
  ),
  atsExplanation: 'Kies het ATS waarmee je wil koppelen',

  more: 'Meer',
  move: 'Versplatsen',
  moveTo: 'Versplatsen Nar',

  contactInfoSetting: 'Toon alleen profielen met contactinformatie',
  activeJobSeekersSetting: 'Toon alleen profielen van kandidaten die actief op zoek zijn',
  newLink: 'nieuwe link',
  insertLink: 'Link invoegen',
  displayText: 'Weergavetekst',
  URL: 'URL',
  removeLink: 'Link verwijderen',
  attachFile: 'Voeg bijlage toe',
  tokensEmpty: 'Token is leeg',

  //Job Boards
  newJobBoard: 'Nieuw Jobsite',
  editJobBoard: 'Bewerk Jobsite',
  invalidCredentials: 'Ongeldige Inloggegevens',
  validATSCredentials: 'Geldige Inloggegevens',
  invalidMfaCode: 'Deze verificatiecode is ongeldig',
  credentialsExpired: 'De inloggegevens zijn verlopen. Voer alstublieft opnieuw uw gebruikersnaam en wachtwoord in.',
  jobBoardCredentialVerificationTitle: 'We verifiëren nu jouw login gegevens.',
  jobBoardCredentialVerificationDescription: 'Even geduld nog. Het kan 1 minuut duren.',
  jobBoardInvalidCredentials:
    'Balen! We hebben jouw login gegevens niet kunnen verifiëren. Controleer je gebruikersnaam en wachtwoord, en probeer het daarna nogmaals.',
  jobBoardDuplicatedCredentials: 'We hebben deze login gegevens al! Je hoeft dus niks meer te doen.',
  jobBoardConnectionActive: 'De connectie is actief.',
  jobBoardConnectionInActive: 'De connectie is inactief.',
  confirmDeleteJobBoard: 'Weet je zeker dat je dit jobsite wilt verwijderen?',
  confirmDisableJobBoard: 'Weet je zeker dat je dit jobsite voor alle gebruikers wilt uitschakelen?',
  jobBoardExplanation: 'Kies het jobsite dat je wilt koppelen',
  jobBoardUsernameExplanation: 'Voer de gebruikersnaam in waarmee je ook inlogt op het jobsite.',
  jobBoardPasswordExplanation: 'Voer het wachtwoord in waarmee je ook inlogt op het jobsite.',
  jobBoardSecret: 'Geheime vraag',
  jobBoardSecretExplanation: 'Voer ter controle de geheime vraag in die je op het jobsite hebt ingevoerd.',
  licenseActive: 'Jouw login gegevens zijn correct.',
  licenseInActive: 'Jouw login gegevens zijn niet correct.',
  license: 'Licentie',
  addLicense: 'Voeg Licentie Toe',

  //ATS
  addNew: 'Nieuw Toevoegen',
  atsVacancy: 'ATS Vacature',
  viewATSConnections: 'Wijzig ATS connectie',
  unableToConnectToATS:
    'Het is niet mogelijk om je ATS te koppelen. Controleer je gegevens of probeer het later opnieuw.',
  myConnections: 'Mijn Koppelingen',
  teamConnections: 'Koppelingen Team',
  usersWithoutConnections: 'Niet Gekoppelde Gebruikers',
  atsKey: 'ATS Key',
  atsUrl: 'ATS URL',
  atsName: 'Naam ATS',
  clientSecret: 'Geheime vraag',
  requestATSConnection:
    'Dit ATS staat nog niet in ons systeem. Vraag een koppeling aan, zodat we het ATS kunnen toevoegen.',
  atsRequestedMessage: (
    <Fragment>
      De koppeling is aangevraagd. We gaan ermee aan de slag! Intussen kun je gewoon verdermet het anmaken van
      zoekopdrachten en het beoordelen van kandidaten.
      <br />
      <br />
      Zodra we weten of de koppeling aan je ATS mogelijk is, hoor je van ons.
    </Fragment>
  ),
  checkOverview: 'Bekijk overzicht',
  confirmDeleteATS:
    'Het verwijderen van je koppeling zal ervoor zorgen dat kandidaten niet meer automatisch naar je ATS gepusht worden.',
  confirmSwitchATS: (ats) => `Je bent al gekoppeld met ATS ${ats}. Weet je zeker dat je wilt wisselen van ATS?`,

  atsUsernameExplanation: 'Vul de gebruikersnaam in die je bij het ATS gebruikt om in te loggen',
  atsPasswordExplanation: 'Vul het wachtwoord in die je bij het ATS gebruikt om in te loggen',
  atsKeyExplanation: "Vul de 'ATS Key' in die je in de instellingen van het ATS vindt",
  atsSecret: 'Client secret',
  atsSecretExplanation: "vul de 'client secret' in die het ATS aangeeft voor de integratie.",
  activate: 'Activeer',
  atsConnectionAltTitle: (id, name) => `ATS-verbinding ${id} naar ${name}`,
  recruiteeWebhookInstruction:
    'Kopieer de onderstaande Webhook-URL naar Recruitee (Instellingen → Apps en Plugins → Webhooks) en plak vervolgens het Secret dat Recruitee toont in het onderstaande veld.',
  webhookUrl: 'Webhook URL',
  webhookSecret: 'Webhook Secret',
  seeDetails: 'zie details',
  /// ATS Credentiasl error Modal
  showMoreErrorDetails: 'Meer foutdetails weergeven',
  atsCredentialsErrorModalBody: 'ATS-verbinding antwoordde met de reden:',
  atsPermissionOk: 'Toestemming OK',
  atsPermissionInvalid: 'Ongeldige toestemming voor deze bron (vraag toegang aan)',

  campaignCompletedTitle: 'Goed bezig!',
  campaignCompletedMessage: (
    <Fragment>
      Je hebt alle kandidaten beoordeeld.
      <br />
      <br />
      Zoek opnieuw of wijzig de zoekopdracht, zodat we op zoek kunnen naar meer profielen.
    </Fragment>
  ),
  campaignGroup1CompletedMessage: (
    <Fragment>
      Je hebt alle kandidaten beoordeeld. Ik heb nog 25 alternatieve kandidaten beschikbaar die minder goed aansluiten
      bij de zoekopdracht en mogelijk toch interessant zijn. Wil je die bekijken?
      <br />
      <br />
      Je kunt de zoekopdracht ook wijzigen, zodat we op zoek kunnen naar meer profielen.
    </Fragment>
  ),
  searchingMoreProfiles: 'Zoeken meer profielen.',
  searchAgain: 'Zoek opnieuw',
  reviewAlternativeCandidates: 'Bekijk alternatieve kandidaten',

  mustBeLessThanMax: 'Moet minder zijn dan maximale werkervaring',
  mustBeMoreThanMin: 'Moet meer zijn dan minimale werkervaring',

  // common
  any: 'Geen voorkeur',
  of: 'van',
  add: 'Toevoegen',
  edit: 'Aanpassen',
  delete: 'Verwijderen',
  deactivate: 'Deactiveer',
  saveChanges: 'Opslaan',
  close: 'Sluiten',
  remove: 'Verwijder',
  mustHave: 'Vereist',
  exclude: 'Uitsluiten',
  saving: 'Opslaan...',
  done: 'Gelukt!',
  loading: 'Aan het laden',
  thisCouldTakeAFewMinutes: 'Dit kan enkele minuten duren',
  changesSaved: 'Wijzigingen opgeslagen',
  invalidUsername: 'Ongeldige gebruikersnaam',
  invalidPassword: 'Invalid wachtwoord',
  clickHere: 'klik hier',
  selectAll: 'Selecteer iedereen',
  selectAllCandidatesWithRj: 'Selecteer alle kandidaten met Rj',
  selectCandidates: 'Selecteer kandidaten',
  rjBulkSelectAllDailyLimitTooltip: 'Je hebt je dagelijkse limiet voor bulk Rj bereikt.',
  runRjAmount: (value: number) => `Rj uitvoeren (${value})`,
  rjBulkOutreachesUsagePillLabel: (used: number, total: number) => `${used}/${total} bulk outreaches vandaag`,
  amountLeftToday: (value: number) => `Nog ${value} vandaag`,
  rjBulkDailyContactLimitDescription: (value: number) =>
    `Met Rj kun je dagelijks maximaal ${value} kandidaten tegelijk benaderen`,
  rjBulkOutreachesLeftToday: (value: number) => `Je hebt nog ${value} bulk outreaches over vandaag`,
  rjBulkDailyLimitReachedQuotaResetsTomorrow:
    'Je hebt je dagelijkse limiet bereikt · je quotum wordt morgen opnieuw ingesteld',
  candidatesSelectedCount: (value: number) =>
    value === 1 ? `${value} kandidaat geselecteerd` : `${value} kandidaten geselecteerd`,
  clearAll: 'Selecteer niemand',
  scrollTo: 'Scroll naar',
  otherwiseNamely: 'Anders, namelijk ...',
  somethingWentWrong: 'Er is iets mis gegaan',
  pleaseTryAgainOrContactUs: 'Probeer het opnieuw. Als het probleem aanhoudt, neem contact met ons op.',
  indeedCandidateAlreadyContacted: 'Deze kandidaat is onlangs al benaderd',
  indeedCandidateEngagementFailed: 'Indeed kon deze kandidaat niet benaderen',
  indeedCandidateRecentlyDeclined: 'Deze kandidaat heeft onlangs een bericht ontvangen en was niet geïnteresseerd',
  indeedCandidateSubscriptionMismatch:
    'Controleer jouw Indeed Smart Sourcing licentie. Deze is mogelijk niet actief en daardoor kan het bericht niet worden verstuurd.',
  notFound: 'Niet Gevonden',
  loggingYouInAutomatically: 'Je wordt automatisch ingelogd',
  couldNotLogYouInAutomatically: 'Kan niet automatisch inloggen',
  attemptNofX: (current: number, max: number) => `Poging ${current} van ${max}.`,
  minimumCharacterValue: (value) => `Gebruik minimaal ${value} tekens`,
  maximumCharacterValue: (value) => `Je kan maximaal ${value} tekens gebruiken`,
  companyNameCannotContainSpecialCharacters: 'De bedrijfsnaam mag geen spaties of speciale tekens bevatten.',
  selectAnOption: 'Kies een optie',
  and: 'en',
  or: 'of',
  expandLess: 'Minder uitbreiden',
  expandMore: 'Meer uitbreiden',
  downloadProfile: 'Profiel downloaden',
  tutorial: 'Zelfstudie',
  emailSuccessfullySent: 'Je email is succesvol verstuurd',
  emailFailedSend: 'Je email is niet verstuurd',
  linkedinSuccessfullySent: 'Je LinkedIn verzoek is succesvol verzonden!',
  linkedinFailedSend: 'Je LinkedIn verzoek is niet verzonden!',
  linkedinInMailSuccessfullySent: 'Je LinkedIn InMail verzoek is succesvol verzonden!',
  liknedinInMailFailedSend: 'Je LinkedIn  InMailverzoek is niet verzonden!',
  indeedSuccessfullySent: 'Je Indeed bericht verzoek is succesvol verzonden!',
  indeedFailedSend: 'Je Indeed bericht verzoek is niet verzonden!',
  sendDisabledIndeedTip: 'Je moet je Indeed account koppelen om dit bericht te versturen',
  sendDisabledLinkedinTip: 'Je moet je LinkedIn account koppelen om dit bericht te versturen',

  //Languages
  english: 'Engels',
  dutch: 'Nederlands',

  //Users
  actions: 'Acties',
  exportToExcel: 'Exporteren naar Excel',
  createNewUser: 'Nieuwe gebruiker aanmaken',
  manageUsers: 'Beheer gebruikers',
  userUnlock: 'Ontgrendelen',
  userActivationSettings: 'Activerings instellingen',
  isActive: 'Actief',
  userSince: 'Aanmaakdatum',
  lastLoggedIn: 'Laatste inlogtijd',
  emailConfirmed: 'E-mailbevestiging',

  userDeactivateConfirmation:
    'Weet u zeker dat u deze gebruiker wilt uitschakelen? Deze actie kan niet ongedaan gemaakt worden',
  userActivateConfirmation: 'Weet je zeker dat je deze gebruiker wilt activeren?',
  userWasUnlockedSuccessfully: 'Ontegrendeid de gebruiker',
  userWasDeletedSuccessfully: 'Succesvol verwijderd',
  userCreatedSuccessfully: 'Met succes opgeslagen',
  userProfileUpdatedSuccessfully: 'Met succes opgeslagen',
  userWasActivatedSucessfully: 'Gebruiker is succesvol geactiveerd',

  editUser: 'Wijzig gebruiker',
  invalidEmailAddress: 'Vul hier een geldig e-mailadres in.',
  invalidPhoneNumber: 'Voer uw telefoonnummer in',
  atLeast6Characters: 'Vereist minimaal 6 tekens',
  atLeast12Characters: 'Vereist minimaal 12 tekens',
  passwordMustContainDigit: 'Vereist minimaal 1 cijfer',
  passwordMustContainUppercase: 'Vereist minimaal 1 hoofdletter',
  passwordMustContainLowercase: 'Vereist minimaal 1 kleine letter',
  passwordIsTheSame: 'Mag niet hetzelfde zijn als het vorige wachtwoord',

  userPasswordSettings: 'Wachtwoord instellingen',
  setNewPassword: 'Stel wachtwoord in',
  setRandomPasswordForUser: 'Stel willekeurig wachtwoord in.',
  shouldChangePasswordOnNextLogin: 'Moet wachtwoord wijzigen bij volgende aanmelding',
  sendActivationEmail: 'Verstuur activeringsmail',
  setUserIsActive: 'Actief',
  setLockOut: 'Vergrendeling ingeschakeld',
  remindPassword: 'Als u uw wachtwoord bent vergeten,',
  incorrectPassword: 'Onjuist wachtwoord',
  passwordsDoNotMatch: 'Wachtwoord komt niet overeen',

  //While the user is logged out
  emailActivation: 'E-mail Activering',
  emailActivationDescription:
    'Er wordt een link naar uw e-mailadres verzonden om uw e-mailadres te activeren. Als u binnen een paar minuten geen e-mail ontvangt, probeert u het opnieuw.',
  emailActivationSentDescription:
    'Een activeringslink voor e-mail verzonden naar uw e-mailadres. Controleer alstublieft uw e-mails.',

  invalidResetLink: 'Ongeldige resetlink',
  invalidResetLinkDescription: 'De door u gebruikte resetlink is niet geldig',
  passwordResetComplete: 'Wachtwoord reset compleet',
  goToLogin: 'Ga naar de inlog pagina',
  goToLoginDescription: 'Je kan nu inloggen met je nieuwe wachtwoord',

  companyNameIsTaken: 'Deze bedrijfsnaam is al in gebruik. Probeer het opnieuw met een andere naam.',

  //Realtime Search filters
  activeFilters: (num) => `actieve filter${num === 1 ? '' : 's'}`,
  filters: 'Filters',
  totalExperience: 'Totale werkervaring',
  location: 'Locatie',
  locations: 'Locaties',
  locationsPlaceholder: 'Bijvoorbeeld Utrecht',
  skillsKeywords: 'Vaardigheden / Steekwoorden',
  skillsKeywordsPlaceholder: 'Bijvoorbeeld Excel',
  mustHaveEmail: 'Email Vereist',
  mustHavePhone: 'Telefoonnummer Vereist',
  sources: 'Bronnen',
  schoolName: 'Opleiding gevolgd bij',
  schoolNamePlaceholder: 'Bijvoorbeeld Universiteit Utrecht',
  educationDegree: 'Opleidingsniveaus',
  educationDegreePlaceholder: 'Bijvoorbeeld HBO',
  educationFields: 'Opleidingsrichting',
  educationFieldsPlaceholder: 'Bijvoorbeeld Human Resource Management',
  sizeOfBatches: 'Aantal kandidaten per batch',
  locationDistanceInKm: 'Afstand (km)',
  industries: 'Industrieën',
  aboutMe: 'Over mij',
  licenses: 'Licenties',
  searchResults: 'Zoekresultaten',
  updatedAt: 'Updated At',
  graduationYear: 'Meest recente afstudeerdatum',
  employmentType: 'Dienstverband',

  //Updated At Filter
  anyTime: 'Geen Voorkeur',
  last24Hours: 'Afgelopen 24 uur',
  last3Days: 'Afgelopen 3 dagen',
  lastWeek: 'Afgelopen Week',
  lastMonth: 'Afgelopen Maand',
  last3Months: 'Afgelopen 3 Maanden',
  last6Months: 'Afgelopen 6 Maanden',
  lastYear: 'Afgelopen Jaar',

  //Employment Type Filter
  employmentTypeFullTime: 'Full time',
  employmentTypePartTime: 'Part time',
  employmentTypeInternship: 'Stage',
  employmentTypeFreelance: 'Freelance',
  employmentTypeShortTerm: 'Tijdelijk',
  employmentTypeSeasonal: 'Seizoensgebonden',

  //Job Title Type Filter
  jobTitleType: 'Ervaring opgedaan tijdens',
  jobTitleTypeAll: 'Volledige werkgeschiedenis',
  jobTitleTypeCurrent: 'Alleen meest recente ervaring',
  jobTitleTypeRecent: 'Twee meest recente ervaringen',
  jobTitleTypePast: 'Alleen eerdere ervaringen',

  //Realtime Search Results
  candidatePreferences: 'Kandidaat voorkeuren',
  interests: 'Interesses',
  source: 'Bron',
  lastUpdated: 'Laatst geupdate',
  lastCrawled: 'Laatst ververst',
  lastMatched: 'Laatst matched',
  lastContacted: 'Laatst gecontacteerd',
  lastHidden: 'Laatst verborgen',
  lastShortlisted: 'Laatst shortlisted',
  couldNotRefreshProfile:
    'We kunnen dit profiel op dit moment niet opnieuw verversen. Het profiel is mogelijk verwijderd bij de bron. Je kan het later opnieuw proberen.',
  profileNotAvailable:
    'We kunnen dit profiel op dit moment niet opnieuw verversen. Het profiel is mogelijk verwijderd bij de bron.',
  phone: 'Telefoonnummer',
  academicExperience: 'Academische Ervaring',
  addSomeFiltersMessage: 'Voeg enkele filters toe om uw zoektocht te starten!',
  noResultsMessage:
    'Ik heb geen kandidaten kunnen vinden met deze filters. Probeer de filters aan te passen en gebruik de chat als je hulp nodig hebt!',
  openToWork: 'Beschikbaarheid',
  credentialsDisabledCallToAction: (platform: string) =>
    `Actie vereist: de logingegevens van ${platform} zijn onjuist. Update de logingegevens en voorkom dat je kandidaten mist.`,
  autoSavedFilters: 'Filters automatisch opgeslagen',

  helpCenter: 'Helpcentrum',
  help: 'Help',

  notifications: 'Meldingen',
  markNotificationAsRead: 'Melding markeren als gelezen',
  markAllAsRead: 'Markeer alles als gelezen',
  seeSearchInList: 'Zie zoeken in lijst',
  year: 'jaar',
  years: 'jaar',
  month: 'maand',
  months: 'maanden',
  inTotal: 'In totaal',
  inFunction: 'In deze functie',
  viewFullProfile: 'Bekijk volledig profiel',
  pleaseWait: 'Even geduld',
  downloadCV: 'Download CV',
  downloadCVs: 'Download CVs',
  pageNumOfNum: (current: number | string, total: number | string) => `Pagina ${current} van ${total}`,
  issued: 'Uitgerijkt',
  resume: 'Introductie',
  licensesAndCertifications: 'Licenties en certificaten',
  jobs: 'Vacatures',
  minWorkHours: 'Min. uren per week',
  maxWorkHours: 'Max. uren per week',
  minSalary: 'Min. salaris',
  maxSalary: 'Max. salaris',
  currency: 'Valuta',
  unlockContactInformation: (price: number) => `Ontgrendel contactinformatie (${price} credit${price >= 2 ? 's' : ''})`,
  saveAndUnlockContactInformation: (price: number) =>
    `Bespaar en ontgrendel contactinformatie (${price} credit${price >= 2 ? 's' : ''})`,
  unlockCV: (price: number) => `Ontgrendel CV (${price} credit${price >= 2 ? 's' : ''})`,
  currentOfTotal: (current: number | string, total: number | string) => `${current} van ${total}`,
  showMore: 'meer weergeven',
  showLess: 'minder weergeven',
  showXMore: (quantity) => `Laat meer ${quantity} zien`,
  showXLess: (quantity) => `Toon ${quantity} minder`,
  showAll: (quantity) => `Alles weergeven (${quantity})`,
  plusMore: (quantity) => `+${quantity} meer`,
  requestContactInformation: 'Vraag contactinformatie op',
  youCanRequestContactInformation:
    'Je kan contactinformatie opvragen. We rekenen één credit als we contactinformatie vinden.',
  thisProfileWasUpdatedTimeAgo: (timeAgo) => `Dit profiel is ${timeAgo} geleden door de kandidaat bijgewerkt`,
  thisProfileWasRefreshedTimeAgo: (timeAgo) => `De kandidaat data is ${timeAgo} geleden door ons ververst`,
  thisProfileWasApprovedTimeAgo: (timeAgo) => `Dit profiel is ${timeAgo} geleden goed gekeurd`,
  loading_ats_synchronization_label: 'Synchroniseert met ATS',
  loading_contact_info_label: 'Zoekt contactinformatie',
  reTriggerATSCandidateSync: 'Stuur opnieuw naar ATS',
  errorSectionTitle: 'Fout',
  errorSectionMissingSkillOrFunction: 'Voeg ten minste één vaardigheid, functietitel of locatie toe',
  hideFromApproved: 'Verberg in goedgekeurd',
  userFormGenericError: 'Er ging iets fout bij het opslaan van de gebruiker',
  userFormEmailAlreadyTakenError: 'Dit e-mailadres (@email) is al in gebruik',
  duplicate: 'Kopiëren',
  copyOf: 'Kopie van',
  clickHereToUpdateSearch: 'Klik hier om je zoekopdracht te verversen met de nieuwe filters',
  orSimplyPress: ({ isMacOs = false }) => (
    <Fragment>
      Of klik op&nbsp;<code>{isMacOs ? 'Cmd' : 'Ctrl'} + Enter</code>
    </Fragment>
  ),

  // Teams
  team: 'Team',
  teams: 'Teams',
  teamName: 'Team naam',
  teamUsers: 'Gebruikers in team',
  manageTeams: 'Beheer teams',
  createNewTeam: 'Maak nieuw team aan',
  createdBy: 'Aangemaakt door',
  createdAt: 'Aangemaakt op',
  editTeam: 'Wijzig team',
  teamDeletionConfirmation:
    'Weet je zeker dat je dit team wilt verwijderen? Deze actie kan niet ongedaan gemaakt worden.',
  teamWasDeletedSuccessfully: 'Team succesvol verwijderd',
  teamCreatedSuccessfully: 'Team succesvol aangemaakt',
  teamUpdatedSuccessfully: 'Team succesvol opgeslagen',
  editTenantEmailSettingsBtn: 'Bedrijfsnotificatie e-mails',
  editTenantEmailSettings: 'Wijzig bedrijfsnotificatie e-mailinstellingen',
  editTenantEmailSettingsExplanation:
    'Deze configuratie werkt alleen als je geen team hebt. U kunt een meldingsconfiguratie instellen voor een team afzonderlijk. Alles wat binnen een specifiek team is ingesteld, overschrijft de hier gedefinieerde instellingen.',
  tenantEmailSettingsCreatedSuccessfully: 'Bedrijfsnotificatie e-mailinstellingen succesvol aangemaakt',
  tenantEmailSettingsUpdatedSuccessfully: 'Bedrijfsnotificatie e-mailinstellingen succesvol aangepast',
  joinTeamSuccessfully: 'Je bent nu onderdeel van het team',
  exitTeamSuccessfully: 'Je bent geen onderdeel meer van dit team',
  join: 'Aanmelden',
  leave: 'Verlaten',
  detailsTeam: 'Team details',

  updateContactInformation: 'Update contactinformatie',
  contactInfoAvailableFrom: (platform: string) => `Contactinformatie beschikbaar van ${platform}`,
  requestHere: 'Vraag hier',
  refreshHappensAutomatically: 'Verversen gebeurt nu automatisch',
  notificationJobbboardNewVersion: (platform: string) =>
    `Er is een nieuwe integratie voor ${platform}! Neem contact met ons op om de nieuwste ${platform} kandidaten te blijven zien.`,

  requestJobboardInformationConfirmationTitle: (platform: string) =>
    `Vraag contactinformatie van kandidaat op bij ${platform}`,
  requestJobboardInformationConfirmationDescription: (platform: string) =>
    `Deze actie kost een ${platform} credit, weet je zeker dat je deze contactinformatie wil opvragen?`,
  requestJobboardInformationConfirmationCancelText: 'Annuleer informatie aanvraag',
  requestJobboardInformationConfirmationConfirmText: 'Vraag contactinformatie op',

  dontPerformThisCheckNextTime: 'Vraag dit niet opnieuw',

  candidateNotFoundTitle: 'Helaas is deze kandidaat niet langer beschikbaar',
  candidateNotFoundSubtitle: 'Het profiel is verwijderd in de originele bron',

  /// Platforms
  indeed: 'Indeed',
  linkedIn: 'LinkedIn',
  linkedInInMail: 'LinkedIn InMail',
  whatsApp: 'WhatsApp',

  /// Contact Modal
  chooseContactTitleModal: 'Kies een contactmethode',
  chooseContactDescriptionModal: (name) => `Selecteer hoe je ${name} wil benaderen`,
  writeEmailTo: (name) => `Verstuur je email naar ${name}`,
  writeMessageTo: (name) => `Verstuur je bericht naar ${name}`,
  sendWithWhatsAppWeb: 'Stuur met WhatsApp Web',
  sendWithIndeed: 'Stuur met Indeed',
  sendLinkedInRequest: 'Stuur LinkedIn Connectieverzoek',
  sendMessage: 'Verstuur bericht',
  sendInMail: 'Stuur Linkedin InMail',
  sentWhatsAppTo: (name: string) => `Whatsapp bericht verstuurd naar ${name}`,
  sentEmailTo: (name: string) => `Email verstuurd naar ${name}`,
  sentOutreachMessageTo: (channel: string, candidateName: string) => `${channel} verstuurd naar ${candidateName}`,
  emailSent: 'Email verzonden',
  emailReceived: 'Email ontvangen',
  emailReceivedFrom: (name: string) => `Email ontvangen uit ${name}`,
  reply: 'Beantwoorden',
  indeedSent: 'Indeed verzonden',
  indeedReceived: 'Indeed ontvangen',
  indeedJobDropdownPlaceholder: 'Voeg vacature toe',
  indeedNoJob: 'Geen vacature toevoegen',
  indeedNoJobsFound: 'Geen vacatures gevonden',
  indeedProjectDropdownPlaceholder: 'Selecteer Indeed project',
  whatsappSent: 'WhatsApp verzonden',
  linkedinConnectionSent: 'LinkedIn connectieverzoek verzonden',
  linkedinInmailSent: 'LinkedIn InMail verzonden',
  sentIndeedTo: (name: string) => `Indeed bericht verstuurd naar ${name}`,
  sentLinkedInTo: (name: string) => `Linkedin connectieverzoek verstuurd naar ${name}`,
  sentLinkedInMailTo: (name: string) => `LinkedIn InMail verstuurd naar ${name}`,
  sentWerknlMailTo: (name: string) => `Werknl bericht verstuurd naar ${name}`,
  sentBy: 'Verstuurd door:',

  callingWith: (candidateName) => <>Aan het bellen met {candidateName}</>,
  sendEmailTo: (candidateName) => `Verstuur E-mail naar ${candidateName}`,
  sendWhatsAppMessageTo: (candidateName) => `Verstuur WhatsApp-bericht naar ${candidateName}`,
  sendIndeedMessageTo: (candidateName) => `Verstuur Indeed-bericht naar ${candidateName}`,
  replyIndeedMessageTo: (candidateName) => `Antwoord Indeed-bericht naar ${candidateName}`,
  sendWerknlMessageTo: (candidateName) => `Verstuur Werk.nl-bericht naar ${candidateName}`,
  newLinkedinMessageTo: (candidateName) => `Verstuur Nieuw LinkedIn-bericht naar ${candidateName}`,
  newLinkedinInMailMessageTo: (candidateName) => `Verstuur Nieuw LinkedIn InMail-bericht naar ${candidateName}`,

  /// Connect Ohne Modal
  connectYourPhoneTitleModal: 'Koppel met WhatsApp',
  connectYourPhoneDescriptionModal:
    'Om WhatsApp berichten te versturen adviseren we je de desktop App te gebruiken. Download en installeer de App op je PC en verbind je mobiele telefoon. Vervolgens kun je aan de slag!',
  showMeHow: 'Bekijk hoe',
  dontShowThisAgain: 'Laat dit niet opnieuw zien',
  imConnected: 'Staat Gekoppeld',
  downloadTheApp: 'Download de app',

  /// Browser Extension Modal
  browserExtensionRequired: 'Browser extensie vereist',
  browserExtensionRequiredDescriptionModal:
    'Onze browser extensie is nodig om Indeed of LinkedIn berichten te versturen naar kandidaten. We zien dat je deze extensie nog niet hebt geïnstalleerd. Klik op de knop om deze te installeren.',
  installTheExtension: 'Installeer de extensie',

  /// Confirm Message Modal
  confirmMessageTitleModal: 'Heb je jouw bericht verstuurd?',
  confirmMessageDescriptionModal:
    'Laat ons weten of je deze kandidaat een bericht hebt gestuurd, zodat wij hun status op de goede manier kunnen updaten',
  messageNotSent: 'Niet verstuurd',
  generatingMessage: (name) => `Bericht genereren voor ${name}...`,
  errorGeneratingMessage: (candidateName) => `Kon geen bericht genereren voor ${candidateName}`,
  failureToSendMessageTo: (name) => `Bericht versturen naar ${name} is mislukt`,
  messageSent: 'Bericht Verstuurd',

  /// Confirm Call Modal
  confirmCallTitleModal: (name) => `Nam ${name} de telefoon op?`,
  confirmCallDescriptionModal:
    'Laat ons weten of je deze kandidaat gesproken hebt, zodat wij hun status op de goede manier kunnen updaten',
  couldntConnect: 'Niet Gecontacteerd',
  connected: 'Gecontacteerd',
  callSaved: 'Opgeslagen',

  /// Fields tips
  campaignNotificationByEmailTip: 'Ontvang email notificaties van kandidaten gevonden voor jouw zoekopdrachten',
  nameSearchTip: 'Vul een naam in die makkelijk te herkennen is, jouw team zal dit ook gebruiken!',
  jobTitleTip: 'Voeg een relevante functietitel in, wij doen daarna 10 suggesties op basis van deze titel',
  jobTitleTypeTip: 'Wanneer de bovengenoemde functies in de ervaring van de kandidaat hebben plaatsgevonden',
  locationDistanceInKmTip: 'Pas de schuifregelaar aan om de gewenste radius in kilometers in te stellen.',
  contactInfoTip:
    'Wanneer beide opties zijn aangevinkt, worden alleen kandidaten getoond die beide in het profiel hebben staan',
  totalExperienceTip: 'Hoeveel werkervaring de kandidaat in totaal op het profiel heeft staan',
  languagesTip: 'Welke talen de kandidaat moet beheersen voor het uitvoeren van de functie',
  lastUpdatedTip: 'Wanneer de kandidaat voor het laatst het profiel heeft bijgewerkt op de jobsites',
  graduationYearTip: 'Meest recente einddatum van genoten opleiding/cursus door de kandidaat',
  schoolNameTip: 'Bij welke opleidingsinstituten de kandidaat een opleiding heeft gevolgd',
  educationDegreeTip:
    'Opleidingsniveau dat de kandidaat ten minste moet hebben. Niet per definitie de hoogst of enige genoten opleiding.',

  /// Admin
  backToSearchCampaigns: 'Terug naar zoekopdrachten',
  createNewCompany: 'Maak een nieuw bedrijf aan',
  editCompany: 'Wijzig bedrijf',
  editUsers: 'Wijzig gebruikers',
  impersonateUser: 'Inloggen als deze gebruiker',
  creditLimit: 'Credit limiet',
  updateUsersSuccessfully: 'Gebruiker is succesvol opgeslagen',
  id: 'Id',
  companyCode: 'Code',
  edition: 'Editie',
  active: 'Actief',
  inactive: 'Inactief',
  credits: 'Credits',
  created: 'Aangemaakt',
  updated: 'Gewijzigd',
  demo: 'Demo',
  standard: 'Standaard',
  tenantHasBeenUpdatedSuccessfully: 'Bedrijf is succesvol opgeslagen',
  tenantHasBeenCreatedSuccessfully: 'Bedrijf is succesvol aangemaakt',
  tenantName: 'Bedrijfsnaam',
  removeSpaces: 'Verwijder spaties',
  subscriptionEdition: 'Abonnementseditie',
  editTenantUsers: 'Wijzig gebruikers van bedrijf',
  editTenantUsersSubtitle: 'De eerste gebruiker in deze lijst is de admin en is verplicht.',
  name: 'Naam',
  firstName: 'Voornaam',
  lastName: 'Achternaam',
  fullName: 'Volledige naam',
  lastPosition: 'Laatste ervaring',
  lastCompany: 'Laatste bedrijf',
  recruiterFullName: 'Recruiter volledige naam',
  nameJobboard: 'Naam Jobsite',
  nameVacancy: 'Naam Vacature',
  addAnotherUser: 'Voeg een gebruiker toe',
  impersonate: 'Inloggen als',
  searchCompany: 'Zoek bedrijf',
  entriesPerPage: 'Resultaten per pagina',

  matchPhase: 'Matchfase',
  none: 'Geen',

  website: 'Website',

  typeYourMessage: 'Schrijf hier je bericht...',
  typeYourMessageRobinJr: 'Schrijf hier je bericht of selecteer een vacature en laat AI de perfecte tekst schrijven...',
  selectHighQualityJob: "Gebruik 'Hoge Kwaliteit' vacatures om 70% meer reacties te krijgen",
  typeYourNote: 'Schrijf hier je notitie...',
  subject: 'Onderwerp',
  signOff: 'Schrijf een groet,',
  featureToggles: 'Features beheren',
  addFeatureToggle: 'Voeg feature toe',
  featureTogglesSearchPlaceholder: 'Zoek op naam of waarde',
  featureTogglesNewLayout: 'Nieuwe weergave',
  featureTogglesEmptyTitle: 'Deze tenant heeft nog geen feature toggles',
  featureTogglesEmptyDescription: 'Voeg de eerste toe om een feature aan te zetten voor deze tenant.',
  featureTogglesNoResultsTitle: 'Geen toggle komt overeen met je zoekopdracht',
  featureTogglesCreateNamed: (name: string) => `Maak "${name}" aan`,
  featureTogglesFilterOn: 'Aan',
  featureTogglesFilterOff: 'Uit',
  featureTogglesStatusNew: 'Nieuw',
  featureTogglesStatusEdited: 'Bewerkt',
  featureTogglesStatusRemoved: 'Verwijderd',
  featureTogglesDuplicateName: 'Een andere toggle gebruikt deze naam',
  featureTogglesNotSavedYet: 'Nog niet opgeslagen voor deze tenant',
  featureTogglesUnsavedChanges: (count: number) =>
    count === 1 ? '1 niet-opgeslagen wijziging' : `${count} niet-opgeslagen wijzigingen`,
  featureTogglesDone: 'Klaar',
  featureTogglesCopyName: 'Kopieer naam',
  featureTogglesNameCopied: 'Naam gekopieerd',
  undo: 'Ongedaan maken',
  title: 'Titel',
  value: 'Waarde',
  enabled: 'Actief',
  emptySubject: 'Je hebt geen onderwerp ingevuld',
  emptyMessage: 'Je hebt geen bericht ingevoerd',
  emptySignOff: 'Je hebt geen groet ingevoerd',
  yearAbbr: 'yr',
  yearsAbbr: 'yrs',
  simplified: 'Vereenvoudigd',
  addLabels: 'Labels toevoegen',
  addLabel: 'Label toevoegen',
  labelAdded: 'Etiket toegevoegd',
  noteAdded: 'Notitie toegevoegd',
  fresh: 'Fresh',
  candidateHasXNotes: (labelsCount) => `Candidate has ${labelsCount} notities`,

  // Candidates Insights
  newCandidate: 'Nieuwe kandidaat',
  updatedInformation: 'Gewijzigde informatie',
  educationAddedRecently: 'Opleiding toegevoegd',
  educationDatesChanged: 'Opleidingsperiode gewijzigd',
  educationEditedRecently: 'Opleiding gewijzigd',
  experienceAddedRecently: 'Ervaring recent toegevoegd',
  jobRoleChanged: 'Functietitel gewijzigd',
  jobDescriptionChanged: 'Functieomschrijving gewijzigd',
  jobDatesChanged: 'Periode van functie gewijzigd',
  skillAddedRecently: 'Skill / vaardigheid recent toegevoegd',
  preferredEmploymentTypeChanged: 'Voorkeur dienstverband gewijzigd',
  preferredWorkHoursChanged: 'Voorkeur uren gewijzigd',
  workAvailabilityChanged: 'Beschikbaarheid recent gewijzigd',
  locationChangedRecently: 'Locatie recent gewijzigd',
  phoneAddedRecently: 'Telefoonnummer recent toegevoegd',
  phoneNumberChanged: 'Telefoonnummer gewijzigd',
  emailAddedRecently: 'E-mailadres recent toegevoegd',
  emailChanged: 'E-mailadres gewijzigd',

  latestActions: 'Laatste acties:',
  titlePlaceholder: 'Naam zoekopdracht',
  refineTheSearchBelow: 'Verfijn zoekopdracht',

  indeedNoCredits: 'Je Indeed account heeft geen credits om een Indeed Email te versturen',
  indeedCreditsUnknown: 'Credits onbekend',
  indeedCreditsOutOfSync: 'Credits mogelijk niet gesynchroniseerd',
  indeedCreditsOutOfSyncDescription:
    'Dit aantal wordt periodiek bijgewerkt en weerspiegelt mogelijk niet je huidige Indeed saldo.',
  indeedCheckBalance: 'Controleer je saldo op Indeed',
  linkedinNoCredits: 'Je LinkedIn account heeft geen credits om een LinkedIn InMail te versturen',
  createNewTemplate: 'Maak nieuw sjabloon',
  nameYourTemplate: 'Geef jouw sjabloon een naam',
  blankTemplate: 'Blanco sjabloon',

  saveTemplate: 'Sjabloon opslaan',
  selectTemplateToUse: (type) => `Selecteer een ${type} sjabloon om te gebruiken`,
  templateSavedSuccessfully: 'Sjabloon succesvol opgeslagen',
  templateTokens: 'Personalisatie tokens',
  lastActioned: 'Laatste actie',
  oldestActioned: 'Oudste actie',
  haveSeenItAll: 'Hoera, je hebt alles bekeken!',
  sharedByFromSearch: ({ userName, searchName }) => (
    <>
      Gedeeld door {userName} uit {searchName}
    </>
  ),
  copyLinkCandidateProfile: 'Kopieer een link naar het kandidatenprofiel',
  linkCopySuccess: 'Link gekopieerd!',
  linkCopyFail: 'Kopiëren van link mislukt',
  youNotHaveAccessProfile: 'Je hebt geen toegang tot het profiel van deze kandidaat',
  tryResendAts: 'Probeer de kandidaat opnieuw naar ATS te sturen',

  emailAndPhoneAvailableUponApproval: (email, phone) => {
    if (email && phone) {
      return `${dictionary.email} en ${dictionary.phone} beschikbaar na goedkeuren`;
    }

    if (phone) {
      return `${dictionary.phone} beschikbaar na goedkeuren`;
    }

    return `${dictionary.email} beschikbaar na goedkeuren`;
  },

  cvAvailableUponApproval: 'CV beschikbaar na goedkeuren',

  changeOwner: 'Wijzig eigenaar',
  currentOwner: 'Huidige eigenaar',
  makeUserSearchOwner: (userName) => `${userName} eigenaar maken (van deze zoekopdracht)?`,
  makeUserSearchOwnerDescription: (
    userName,
  ) => `Je bent niet meer de eigenaar van deze zoekopdracht omdat ${userName} nu eigenaar wordt.
  `,
  goAhead: 'Ga verder!',
  currentSearch: 'Huidige zoekopdracht',
  labelsChanged: 'Labels gewijzigd',
  notes: 'Notities',
  deleteNote: 'Verwijder notitie',
  editNote: 'Bewerk notitie ',
  startTypingYourNotesHere: 'Schrijf je notities hier',
  moreInfoSent: 'Meer info gestuurd',
  noAnswer: 'Geen gehoor',
  notResponding: 'Reageert niet',
  notInterested: 'Geen interesse',
  interested: 'Geïnteresseerd',
  showQuestionnaire: 'Vul de vragenlijst in',
  declined: 'afgewezen',
  positiveOutcomes: 'Positief resultaat',
  neutralOutcomes: 'Neutraal resultaat',
  negativeOutcomes: 'Negatief resultaat',
  customLabels: 'Eigen labels',
  createCustomLabel: 'Maak eigen label aan',
  removed: 'Verwijderd',
  paymentMethod: 'Betaalmethode',
  triggerToSendCandidateToAts: 'Trigger om kandidaat naar ATS te sturen',
  chooseAnOption: 'Selecteer een optie',
  selectATemplateToUse: (type) => {
    if (type === 'email') return 'Selecteer een e-mail sjabloon om te gebruiken';
    if (type === 'indeed') return 'Selecteer een Indeed sjabloon om te gebruiken';
    if (type === 'linkedin') return 'Selecteer een LinkedIn sjabloon om te gebruiken';
    if (type === 'whatsapp') return 'Selecteer een WhatsApp sjabloon om te gebruiken';
    if (type === 'werknl') return 'Selecteer een Werknl sjabloon om te gebruiken';
    return 'Selecteer een telefoon sjabloon om te gebruiken';
  },
  templates: 'Sjablonen',
  whatsAppTemplatesDisabledTitle: 'Sjablonen zijn uitgeschakeld voor WhatsApp',
  whatsAppTemplatesDisabledDescription:
    'WhatsApp kan je account beperken wanneer hetzelfde bericht naar veel mensen wordt gestuurd. Schrijf in plaats daarvan een bericht voor deze kandidaat.',
  whatsAppTemplatesDisabledLearnMore: 'Waarom dit gebeurt',
  whatsAppTemplatesDisabledHide: 'Verbergen',
  whatsAppTemplatesDisabledReasonSameText:
    'WhatsApp let op dezelfde tekst die naar veel nieuwe contacten wordt gestuurd.',
  whatsAppTemplatesDisabledReasonPersonalize: 'Pas een paar regels per kandidaat aan, ook kleine wijzigingen.',
  whatsAppTemplatesDisabledReasonSpread: 'Stuur minder berichten tegelijk en verspreid ze over de dag.',
  templateName: 'Sjabloonnaam',
  nameTheTemplate: 'Geef het sjabloon een naam',
  newOutreach: 'Nieuw bericht',
  content: 'Inhoud',
  connectYourCalendar: 'Koppel je kalender',
  configureYourCalendar: 'Stel je kalender in',
  openSettings: 'Open instellingen',
  calendarSettings: 'Kalender instellingen',
  yourCalendarIsConnected:
    'Je kalender is verbonden. Werk hier je beschikbaarheid, werktijden en interviewvoorkeuren bij.',
  yourCalendarIsNotConnected: 'Je kalender is niet verbonden',
  toUseInterviewScheduler:
    'Om de interviewplanner te gebruiken, verbind je kalender. Zo kan Robin je beschikbaarheid tonen, dubbele boekingen voorkomen en uitnodigingen automatisch versturen.',
  signature: 'Handtekening',
  signatureSave: 'Handtekening opslaan',
  signaturePlaceholder: 'Voer hier je handtekening in...',
  signatureDescription: 'Pas je e-mailhandtekening aan voor uitgaande berichten.',
  signatureImageHelper: 'We ondersteunen jpg en png',
  signaturePullButton: 'Handtekening importeren',
  signaturePullErrorTitle: 'We konden je handtekening niet importeren',
  signaturePullErrorBody: (
    <span>
      Het is helaas niet gelukt om je handtekening op te halen uit je laatste e-mail.
      <br />
      Geen probleem. je kunt deze handmatig toevoegen met onze stapsgewijze uitleg.
    </span>
  ),
  addManually: 'Handmatig toevoegen',
  addSignatureManually: 'Handtekening handmatig toevoegen',
  enableProviderFirst: 'Koppel eerst je email!',
  signatureSaving: 'Handtekening aan het opslaan...',
  signatureSaveError: 'Fout bij opslaan. Handtekening is niet opgeslagen',
  signatureSaveErrorImageConversion:
    'De handtekening kon niet worden opgeslagen vanwege een fout met de afbeeldingen die in de HTML zijn ingebed',
  signatureSaveSuccess: 'Handtekening succesvol opgeslagen',
  manualSignatureSelectionTitle: 'Selecteer je handtekening',
  manualSignatureSelectionDescription: (
    <Fragment>
      We konden je handtekening niet automatisch vinden.
      <br />
      Selecteer hieronder een van uw recente e-mails, markeer jouw handtekening en klik op 'Handtekening invoegen'
      <br />
      Hulp nodig?{' '}
      <a
        href="https://help.recruitrobin.com/nl/articles/11060587-e-mailhandtekening-importeren-in-robin"
        target="_blank"
        rel="noreferrer">
        Lees hier hoe je jouw handtekening kunt importeren.
      </a>
    </Fragment>
  ),
  manualSignatureSelectionCapture: 'Selectie vastleggen',
  manualSignatureSelectionInsert: 'Handtekening invoegen',
  manualSignatureSelectionPreview: 'Voorbeeld van je selectie:',
  manualSignatureSelectionHighlightError: 'Selecteer eerst de handtekening',
  calling: 'Aan het bellen met',
  candidateNotes: 'Kandidaatnotities',
  successfull: 'Succesvol',
  candidateSentToAts: (candidateFirstName: string, atsName: string) => (
    <Fragment>
      {candidateFirstName} is verplaatst naar 'matched'
      <br />
      en direct toegevoegd aan {atsName}
    </Fragment>
  ),
  candidateNotSentToAts: 'Kandidaat niet naar ATS verzonden',
  candidateMissingContactInfoForAts:
    'Exporteren mislukt: Kandidaat mist een e-mailadres of telefoonnummer en kan daardoor niet automatisch worden doorgestuurd naar ATS.',
  searchNotConnectedToAtsJob:
    'Deze zoekopdracht is niet gekoppeld aan een vacature. Koppel een vacature om kandidaten naar het ATS te sturen.',
  unsuccessfull: 'Niet succesvol',
  findMoreGreatCandidates: 'Vind meer goede kandidaten',
  tryAnotherOutreachMethod: 'Probeer een andere contactmethode',
  outreachPhoneSuccessfullHeaderText: 'Goed gewerkt, wat was het resultaat van het gesprek?',
  outreachPhoneUnsuccessfullHeaderText: 'Jammer dat het gesprek niet succesvol was. Wat was de reden?',
  filterByLabel: 'Filter op label',
  atsJobStatusesSelectionLabel: 'Vacature statussen om te synchroniseren',
  atsJobLabelsSelectionLabel: 'Vacature labels om te synchroniseren',
  atsCandidateStatusesSelectionLabel: 'Kandidaatstatussen om te synchroniseren',
  atsConnexysJobStatusDefaultFilterNotice:
    "Als hier geen vacaturestatus is geselecteerd, worden vacatures standaard gefilterd op 'Open' en 'On hold'.",
  outreachResponseNoticeEmail: 'We mailen namens jou. Alle berichten staan in je inbox in Robin',
  outreachResponseNoticeWhatsApp: 'WhatsApp reacties verschijnen direct in je persoonlijke WhatsApp.',
  outreachResponseNoticeInMail: 'InMail reacties verschijnen direct in je LinkedIn account',
  outreachResponseNoticeLinkedIn: 'Reacties op LinkedIn connectieverzoeken verschijnen zowel in LinkedIn als in Robin',
  outreachResponseNoticeIndeed: 'Reacties op Indeed berichten kun je lezen in Robin.',
  outreachResponseNoticeWerknl: (
    <span>
      Verzonden werk.nl-berichten verschijnen niet in je outbox omdat wij berichten namens jou versturen.
      <br />
      Antwoorden worden naar je e-mail inbox gestuurd.
    </span>
  ),
  jobboardRestrictionMessage: (days, platform) =>
    `Door restricties van ${platform} is het pas mogelijk om deze kandidaat over ${days} ${
      days === 1 ? 'dag' : 'dagen'
    } weer een nieuw bericht te sturen`,
  unavailableOnThisContactMethod: 'Niet beschikbaar',
  browserExtensionNotInstalled: 'Installeer onze browser extensie',
  needsLoginOnJobboard: 'Login op platform',
  needsConnectMobileApp: 'Download en log in op de mobiele Robin-app',
  notesModificationHistory: 'Notities veranderen de geschiedenis',
  lastEditedBy: 'Laatst bewerkt door',
  seeFullHistory: 'Zie volledige geschiedenis',
  emailCandidate: 'E-mail kandidaat',
  callCandidate: 'Bel kandidaat',
  workingOnIt: 'Aan het laden…',
  call: 'Bel',
  callMobileByPushNotification: 'Bellen via mobiele app',
  searchNameOrOwnerOfTheSearch: 'Naam zoekopdracht of eigenaar (voornaam, achternaam of e-mail)',
  candidateNoLongerAvailable: 'Deze kandidaat is niet meer beschikbaar',
  canceledByUser: 'Geannuleerd door gebruiker',
  callingIsAutomaticDescription:
    'Bellen gaat automatisch als je een VoIP systeem hebt of je telefoon gekoppeld staat aan jouw computer',
  makeActive: 'Activeer',
  makeInactive: 'Deactiveer',
  filterBy: 'Filter op',
  lastContactedBy: ({ when }) => `Deze kandidaat is ${when} benaderd`,
  noTemplateAvailable: 'Geen sjabloon beschikbaar',
  createNewSearch: 'Maak nieuwe zoekopdracht',
  creatingNewSearch: 'Zoekopdracht wordt aangemaakt...',

  consumerKey: 'Consumer key',
  consumerSecret: 'Consumer secret',

  atsConnectedSuccessfully: (ats) => `${ats} succesvol gekoppeld`,
  weAreConnectingToYourATS: 'We koppelen nu met je ATS...',
  atsCandidateStatusChanged: 'Kandidaatstatus gewijzigd',
  atsNoteAdded: 'Notitie toegevoegd',
  atsEmailSent: 'Email verzonden',
  noCreditsAvailable: 'Geen tegoeden beschikbaar',
  selectAProject: 'Selecteer een project',
  emailOrPhone: 'Email of telefoonnummer',
  candidateSuccessfullyShortlistedToAnotherSearch: 'Kandidaat succesvol geshortlist voor andere zoekopdracht',

  noCreditsAvailableForMonsterboardTitle: 'Je Monsterboard credits zijn op.',
  noCreditsAvailableForMonsterboardDescription: () => (
    <>
      Daarom heb je geen toegang meer tot contactinformatie van Monsterboard kandidaten. Nieuwe credits kun je aanvragen
      op <strong>support@recruitrobin.com</strong>. Je ontvangt dan een voorstel van ons. Het voorstel is kosteloos en
      wordt toegezonden aan de 'admin' van jouw Robin account
    </>
  ),
  errorRetrievingDepartments: 'Fout bij het ophalen van afdelingen',
  noDepartmentsFound: 'Geen afdelingen gevonden, controleer uw RecruitNow dashboard',
  activateBeforeSearchDepartments: 'U moet deze gebruiker activeren voordat u een afdeling selecteert',
  candidateAlreadyInteracted: 'Deze kandidaat is eerder behandeld',
  candidateAlreadyLinkedToAnotherMatch:
    'Deze kandidaat hoort bij een ander matchprofiel. We hebben hem voor je verborgen.',
  newVersionAvailable: 'Nieuwe versie beschikbaar',
  newVersionAvailableDescription: () => (
    <>
      <u>Klik hier</u> om de nieuwe versie te laden
    </>
  ),
  indeedSessionOutdated: 'Indeed sessie verlopen',
  indeedSessionOutdatedDescription: (onLinkClick?: () => void) => (
    <>
      Je Indeed sessiegegevens zijn verouderd.{' '}
      <a href="https://employers.indeed.com/" target="_blank" rel="noreferrer" onClick={onLinkClick}>
        Bezoek Indeed
      </a>{' '}
      om te vernieuwen.
    </>
  ),
  continue: 'Doorgaan',
  languageSelection: 'Taal selectie',
  googleTranslateMessage: () => (
    <span>
      Het gebruik van de automatische vertaler in Google Chrome zorgt ervoor dat ons programma onbruikbaar wordt. Om een
      werkende app te garanderen kan je ons programma niet gebruiken tot je dit uitschakelt.{' '}
      <a href="https://help.recruitrobin.com/nl/articles/8286616-gekke-vertalingen" target="_blank" rel="noreferrer">
        Lees hier hoe je dat doet!
      </a>
    </span>
  ),
  maxAsteriskReached: 'sorry, je hebt de limiet van 5 functietitels met een * overschreden',
  maxAsteriskReachedModalDescription:
    'In het veld functietitels of vaardigheden/trefwoorden zijn maximaal 5 sterretjes (*) toegestaan. Bewerk je zoekopdracht om door te gaan.',
  maxAsteriskReachedModalClickHere: ({ href }) => (
    <span>
      <a href={href} target="_blank" rel="noreferrer">
        Klik hier{' '}
      </a>{' '}
      voor meer informatie.
    </span>
  ),
  hideCandidatesThat: 'Verberg kandidaten met status',
  forPeriodOf: 'In periode van',
  aiSuggestions: 'AI suggesties',
  searchInputPlaceholder: 'vb. Operator in Utrecht met MBO, Jan Bakker, 0612345678',
  findCandidates: 'Kandidaten vinden',
  lastSearches: 'Recente zoekopdrachten',
  noSearchesFound: 'Geen zoekopdrachten gevonden',
  didntFindJobTitleLocation: 'Geen functietitel of locatie gevonden. Probeer het opnieuw',
  robinYearWrapped: ({ year }) => `Robin ${year} wrapped`,
  robinWrapped: 'Robin wrapped',
  downloadYearWrapped: ({ year }) => `Download the ${year} wrapped`,
  wrappedYear: ({ year }) => `${year} Wrapped`,
  wrappedSummary: ({ tenantName }) => `Een uitgebreid overzicht van de activiteit "${tenantName}"`,
  matchedInYear: ({ year }) => `Matched in ${year}`,
  shortlistedInYear: ({ year }) => `Shortlisted in ${year}`,
  contactedInYear: ({ year }) => `Gecontacteerd in ${year}`,
  topJobboard: 'Top jobsite',
  mostActiveUser: 'Meest actieve gebruikers',
  totalAction: 'Totaal acties',
  lengthLimitReached: 'Lengte limiet bereikt',
  getConnectedInstantly: 'Koppel de app!',
  downloadOurMobileApp: 'Download onze app',
  downloadOurMobileAppDescription:
    ' en accepteer notificaties. Na deze 2 simpele stappen kan je direct beginnen met automatisch bellen',
  yourCallIsJustATapAway: 'Direct bellen!',
  checkYourPhoneForADirectCall: "Check je telefoon voor de 'Direct call' notificatie van Robin en start met bellen.",
  downloadRobinMobileApp: 'Download Robin app!',
  selectYourDevicePlatform: 'Selecteer het platform van je apparaat om onze app te downloaden.',
  tapToCallCandidate: (candidateName) => `Klik om "${candidateName}" te bellen!`,
  youCanCopyTheLinkPressingCtrlC: 'Je kunt de link kopiëren via Ctrl (Command) + C',
  info: 'Informatie',
  success: 'Succes',
  error: 'Fout',
  warning: 'Waarschuwing',
  communicationChannelsWarning: 'Niet alle communicatiekanalen zijn gekoppeld. Je kunt belangrijke berichten missen.',
  welcomeBack: 'Welkom terug!',

  dashboard: 'Dashboard',
  summary: 'Samenvatting',
  summaryOfActions: 'Samenvatting van acties',
  addSummary: 'Voeg samenvatting toe',
  removeSummary: 'Verwijder samenvatting',
  allCampaigns: 'Alle zoekopdrachten',
  allUsers: 'Alle gebruikers',

  overviewOfActions: 'Overzicht van acties',
  onlyLastThreeMonths: 'Laatste 3 maanden',

  mostUsedJobboardsForMatched: (method: string) => `Aantal ${method.toLowerCase()} per jobsite`,
  leaderboard: 'Leaderboard',
  summaryOfActivityForUsers: 'Activiteiten van gebruikers / teams',
  allActions: 'Alle acties',
  campaignCreated: 'Zoekopdracht gestart',
  campaignListEmptyStateMessage:
    'Gebruik de zoekbalk hierboven om een nieuwe zoekopdracht te starten en vind de perfecte kandidaten op meerdere vacaturesites',

  exportInPDF: 'Download PDF',
  noMoreResults: 'Geen resultaten meer',
  usersSelected: 'gebruikers geselecteerd',
  campaignsSelected: 'campagnes geselecteerd',
  clickHereToLoginBackIn: 'Om te verbinden, klik op de knop en login op je',
  loginSuccessfully: 'Succesvol ingelogd',
  browserExtensionIsDisabledOrNotInstalled:
    'De browser extensie is uitgeschakeld of niet geïnstalleerd. Controleer de status of installeer opnieuw via de button!',
  clickHereToRefreshThisPage: 'Klik hier om de pagina te verversen',
  toDisconnectClickTheButton: 'Om de verbinding te verbreken, klik op de knop en log uit je',

  shouldInstallBrowserExtensionTitle: 'Robin extension',
  shouldInstallBrowserExtensionModal: (
    <span>
      Je hebt onze browser extensie niet geïnstalleerd. Onze extensie is noodzakelijk om via Robin contact te leggen met
      kandidaten van LinkedIn en Indeed en als bonus krijg je elk uur een notificatie van nieuw gevonden kandidaten!
      <br />
      Installeren is super simpel en doe je{' '}
      <a
        href="https://chromewebstore.google.com/detail/recruit-robin/edfebfbdfncaeokbcjehncoelddchlhi?hl=nl"
        target="_blank"
        rel="noreferrer">
        via hier
      </a>
      !
    </span>
  ),
  shouldCallWerknlOutreachTitle: 'Ketenmachtiging ontbreekt',
  shouldCallWerknlOutreachModal: (
    <span>
      Berichten versturen via Werk.nl is voor jouw organisatie nog niet actief. We hebben een machtiging nodig om het
      versturen van berichten te activeren. Vraag je manager om contact op te nemen via{' '}
      <a href="mailto:support@recruitrobin.com">support@recruitrobin.com</a> of{' '}
      <a
        href="https://intercom.help/recruit-robin/nl/articles/9320876-robin-machtigen-voor-werk-nl-eherkenning"
        target="_blank"
        rel="noreferrer">
        deze stappen
      </a>{' '}
      te doorlopen.
    </span>
  ),
  shouldCallWerknlOutreachDoesntSatisfyAuthorizationTitle: 'Je hebt wel een machtiging, maar niet de juiste rechten',
  shouldCallWerknlOutreachDoesntSatisfyAuthorizationModal: 'Pas je rechten aan in de eHerkenning-instellingen.',
  shouldCallWerknlOutreachAuthorizationExpiredTitle: 'Je machtiging is verlopen',
  shouldCallWerknlOutreachAuthorizationExpiredModal: 'Verleng je machtiging om verder te kunnen.',
  linkedinRunOutCreditsMessage:
    'Je hebt al je 5 gratis persoonlijke uitnodigingen voor deze maand gebruikt. LinkedIn wordt volgende maand gereset. Je kunt nog steeds connectieverzoeken sturen.',
  linkedinRunOutCreditsSendMessage: 'Stuur een LinkedIn-connectieverzoek',
  linkedinRunOutCreditsSendingMessage: ({ onClick }) => {
    return (
      <span>
        Sorry, je bericht is niet verzonden.
        <br />
        Je had geen credits meer om berichten
        <br />
        te versturen op LinkedIn. Je kunt nog
        <br />
        steeds connectieverzoeken sturen.
        <br />
        <b onClick={onClick} style={{ cursor: 'pointer' }}>
          <u>Click here</u>
        </b>{' '}
        om een connectieverzoek te sturen.
      </span>
    );
  },
  werknlMessageTo: (name) => `Werk.nl-bericht aan ${name}`,
  werknlInputEmail: 'E-mail (vereist als telefoon niet opgegeven is)',
  werknlInputPhone: 'Telefoon (vereist als e-mail niet opgegeven is)',

  settings: 'Instellingen',
  emailSettings: 'E-mailinstellingen',
  schedulerEditor: 'Planner Editor',
  connectEmailAccount: 'Koppel je email',
  reconnectEmailAccount: 'Verbind opnieuw',
  disconnectEmailAccount: 'Ontkoppel e-mail',
  theConnectionWasASuccess: 'Koppeling succesvol!',
  theConnectionWasASuccessDescription: 'Jouw e-mail is gekoppeld aan Robin. Je kan nu e-mails versturen met Robin.',
  backToRobin: 'Terug naar Robin',
  emailConnectedDescription: 'Jouw e-mail is gekoppeld aan Robin. Je kan nu e-mails versturen met Robin.',
  connectYourEmailToContinue: 'Koppel je e-mail om verder te gaan',
  shouldConnectEmailDialogDescription: (
    <>
      Verbind je Gmail- of Outlook-account om e-mails te versturen/ontvangen en je positieve reacties bij te houden.
      <ul>
        <li>
          Problemen met koppelen? Mail ons via <a href="mailto:support@recruitrobin.com">support@recruitrobin.com</a>
        </li>
      </ul>
    </>
  ),
  emailConnected: 'E-mail gekoppeld',
  yourEmailIsConnectedAndReadyToUse: 'Je e-mail is gekoppeld en klaar voor gebruik.',
  ok: 'Oke',
  verifyingConnection: 'Verbinding wordt gecontroleerd',
  verifyConnection: 'Verbinding controleren',
  tryAgain: 'Opnieuw proberen',
  pleaseWaitWhileWeVerifyYourEmailConnection: 'Even geduld terwijl we je e-mailverbinding controleren',
  errorWhileConnectingEmail: 'Fout bij het verbinden met e-mail',
  errorWhileConnectingEmailDescription:
    'Er is een fout opgetreden bij het verbinden met je e-mail. Probeer het opnieuw of controleer je bestaande verbinding.',
  emailCopiedCandidateMarkedAsContacted: 'E-mail gekopieerd. Kandidaat gemarkeerd als gecontacteerd.',
  emailNotConnectedDescription: (
    <span>
      Verbind je bedrijfsmail aan Robin om de conversie op e-mails te vergroten!{' '}
      <a href="https://help.recruitrobin.com/nl/articles/9414745-e-mail" target="_blank" rel="noreferrer">
        Lees hier meer
      </a>
    </span>
  ),
  emailConnections: 'Gekoppelde e-mails',
  sharedCalendarSettings: 'Instellingen gedeelde agenda',
  availableTimes: 'Beschikbare tijden',
  meetingEventTitle: 'Titel van de afspraak',
  meetingDuration: 'Duur van het gesprek',
  bookingInterval: 'Boekingsinterval',
  availableDays: 'Beschikbare dagen',
  timezone: 'Tijdzone',
  sharedCalendars: 'Gedeelde agenda’s',
  sharedCalendarsDescription:
    'Selecteer de gebruikers van wie de agenda wordt gebruikt om gesprekstijden aan kandidaten aan te bieden.',
  sharedCalendarsSelectedCount: (selected: number, max: number) => `${selected} / ${max} geselecteerd`,
  sharedCalendarsLimitReached: 'Je kunt maximaal 10 gebruikers selecteren.',
  calendarConnected: 'Agenda gekoppeld',
  calendarNotConnected: 'Agenda niet gekoppeld',
  minutesShort: (minutes: number) => `${minutes} min`,
  hoursShort: (hours: number) => (hours === 1 ? '1 uur' : `${hours} uur`),
  daysShort: (days: number) => (days === 1 ? '1 dag' : `${days} dagen`),
  workingDaysShort: (days: number) => (days === 1 ? '1 werkdag' : `${days} werkdagen`),
  invalidTimeRange: 'De eindtijd moet later zijn dan de starttijd.',
  bookingWindow: 'Boekingsvenster',
  bookingWindowDescription:
    'Hoe kort van tevoren een gesprek geboekt kan worden, en hoe ver vooruit het mag liggen. Geldt zowel wanneer een kandidaat boekt als wanneer die een bestaand gesprek verzet.',
  bookingWindowMin: 'Minimale aankondigingstijd',
  bookingWindowMinHelp: 'Kandidaten kunnen een gesprek tot zo kort voor de start boeken of wijzigen.',
  bookingWindowMinTooltip: 'Tot dit moment kunnen kandidaten boeken of verzetten.',
  bookingWindowWorkingDays: 'Tel in werkdagen',
  bookingWindowWorkingDaysTooltip:
    'Rekent de minimale aankondigingstijd in werkdagen, zonder weekenden, zodat je team steeds de volledige tijd heeft om zich op een boeking voor te bereiden.',
  bookingWindowMax: 'Maximaal venster',
  bookingWindowMaxHelp:
    'Hoe ver vooruit een gesprek geboekt kan worden, gerekend vanaf de dag waarop de kandidaat boekt.',
  bookingWindowMaxTooltip: 'De verste datum die een kandidaat kan kiezen — verzetten schuift die niet op.',
  bookingWindowNoLimit: 'Geen limiet',
  noUsersAvailable: 'Geen gebruikers beschikbaar.',
  bookingPool: 'Boekingspool',
  bookingPoolName: 'Naam van de pool',
  bookingPoolNamePlaceholder: 'bijv. Interviewers',
  bookingPoolNameRequired: 'Een naam voor de pool is verplicht.',
  addBookingPool: 'Pool toevoegen',
  createBookingPool: 'Pool aanmaken',
  noBookingPoolsDescription: 'Maak je eerste boekingspool aan om gesprekstijden aan kandidaten te kunnen aanbieden.',
  bookingPoolNoLongerAvailable: 'Deze boekingspool is niet meer beschikbaar.',
  intakeScheduling: 'Intake inplannen',
  intakeSchedulingDescription: 'Welke groep mensen behandelt elke stap van de intake.',
  intakeSchedulingNoPools: 'Maak hierboven een boekingspool aan om intakestappen toe te wijzen.',
  intakeStepInterview: 'Gesprek met een recruiter',
  liveOnboardingTitle: 'Live onboarding',
  liveOnboardingDescription: 'Welke stad groepssessies organiseert, en wanneer.',
  liveOnboardingNoCities: 'Nog geen stad organiseert groepssessies.',
  liveOnboardingAddCity: 'Stad toevoegen',
  liveOnboardingNewCity: 'Nieuwe stad',
  liveOnboardingPlacesCount: (count: number) => (count === 1 ? '1 plek' : `${count} plekken`),
  liveOnboardingNoTimesSet: 'Nog geen tijden',
  liveOnboardingPaused: 'Gepauzeerd',
  liveOnboardingFieldCity: 'Stad',
  liveOnboardingFieldCityHelp:
    'Kandidaten die op een vacature in deze stad solliciteren worden voor deze sessies uitgenodigd. Exacte match, dus "Amsterdam" en "Amsterdam-Zuidoost" zijn verschillende plaatsen.',
  liveOnboardingFieldName: 'Naam',
  liveOnboardingFieldNameHelp: 'Alleen voor je team. Kandidaten zien dit nooit.',
  liveOnboardingFieldLocationName: 'Locatie',
  liveOnboardingFieldLocationNameHelp: 'De naam die kandidaten boven het adres lezen, bijvoorbeeld "Greenlight Hub".',
  liveOnboardingFieldLocationAddress: 'Adres',
  liveOnboardingFieldLocationAddressHelp: 'Waar kandidaten naartoe komen. Zij zien dit volledig.',
  liveOnboardingFieldDefaultCapacity: 'Plekken per sessie',
  liveOnboardingFieldMinWorkingDays: 'Minimale opzegtermijn',
  liveOnboardingNoticeSameDay: 'Dezelfde dag',
  liveOnboardingFieldCutoffTime: 'Dagelijkse deadline',
  liveOnboardingCutoffNever: 'Dezelfde dag telt nooit mee',
  liveOnboardingFieldMaxDays: 'Maximale periode',
  liveOnboardingFieldRescheduleWindow: 'Deadline voor verzetten',
  liveOnboardingFieldRescheduleWindowHelp: 'Hoe kort voor hun sessie een kandidaat nog kan verzetten.',
  liveOnboardingRescheduleUntilStart: 'Tot de sessie begint',
  liveOnboardingFieldReminder: 'Herinnering',
  liveOnboardingReminderNone: 'Geen herinnering',
  liveOnboardingReminderHour: 'Een uur ervoor',
  liveOnboardingReminderFourHours: 'Vier uur ervoor',
  liveOnboardingReminderDay: 'Een dag ervoor',
  liveOnboardingReminderTwoDays: 'Twee dagen ervoor',
  liveOnboardingFieldCalendar: 'Zet deze sessies ook in een agenda',
  liveOnboardingCalendarNone: 'Geen agenda',
  liveOnboardingCalendarShared: 'gedeeld',
  liveOnboardingCalendarsEmpty: 'Verbind een agenda om de sessies in de agenda van je team te zien.',
  liveOnboardingBookingRules: (workingDays: number, cutoff: string) =>
    `Kandidaten moeten minimaal ${workingDays} ${workingDays === 1 ? 'werkdag' : 'werkdagen'} voor de sessie boeken. Boekingen na ${cutoff} tellen als de volgende werkdag.`,
  liveOnboardingBookingRulesNoCutoff: (workingDays: number) =>
    `Kandidaten moeten minimaal ${workingDays} ${workingDays === 1 ? 'werkdag' : 'werkdagen'} voor de sessie boeken. De dag waarop ze boeken telt nooit mee.`,
  liveOnboardingWorkingDaysNote:
    'Werkdagen zijn maandag tot en met vrijdag, en dat staat vast. Een kandidaat die op vrijdag na de deadline boekt, kan geen sessie op maandag nemen — dinsdag is de eerste die hij kan bereiken. Een feestdag telt gewoon als werkdag, dus gebruik Annuleren hieronder om een specifieke datum af te zeggen.',
  liveOnboardingCityTaken: 'Deze stad heeft al live onboarding. Open de rij hierboven om die aan te passen.',
  liveOnboardingGridTitle: 'Wanneer de sessies zijn',
  liveOnboardingAddTime: 'Tijd toevoegen',
  liveOnboardingFieldDuration: 'Duur',
  liveOnboardingCapacityDefault: (count: number) => `${count} (standaard)`,
  liveOnboardingCapacityNote:
    'Het aanpassen van de plekken verkleint bestaande sessies niet — elke sessie houdt de limiet waarmee hij is aangemaakt.',
  liveOnboardingRemoveTime: 'Deze tijd uitzetten',
  liveOnboardingRestoreTime: 'Weer aanzetten',
  liveOnboardingTimeOff: 'Uit',
  liveOnboardingOffTimeNote:
    'Een tijd uitzetten stopt nieuwe boekingen daarvoor. Sessies die er al uit zijn ontstaan, en de kandidaten daarin, blijven staan — en je kunt de tijd weer aanzetten.',
  liveOnboardingRecurrenceTaken: 'Deze dag en tijd bestaat al. Er is niets opgeslagen.',
  liveOnboardingTimetableFailed: 'De stad is opgeslagen, maar de tijden niet. Open de rij om ze in te stellen.',
  liveOnboardingSessionsTitle: 'Komende sessies',
  liveOnboardingSessionsEmpty: 'Geen sessies in de komende twee weken.',
  liveOnboardingSessionsTimezoneNote: (timezone: string) => `Tijden in ${timezone}`,
  liveOnboardingSessionPlaces: (taken: number, capacity: number) => `${taken} / ${capacity} plekken`,
  liveOnboardingSessionFull: 'vol',
  liveOnboardingSessionCancelled: (reason: string | null) => (reason ? `geannuleerd — ${reason}` : 'geannuleerd'),
  liveOnboardingWhosComing: 'Wie komt er',
  liveOnboardingAttendeesEmpty: 'Nog niemand heeft deze sessie geboekt.',
  liveOnboardingCancelSession: 'Annuleren',
  liveOnboardingCancelTitle: 'Deze sessie annuleren?',
  liveOnboardingCancelBodyEmpty: 'Niemand heeft deze sessie geboekt. Dit kan niet ongedaan worden gemaakt.',
  liveOnboardingCancelBody: (count: number) =>
    count === 1
      ? '1 kandidaat heeft een plek. Hij krijgt een e-mail met een excuus en een link om een andere sessie te kiezen, en zijn agenda-item wordt ingetrokken. Dit kan niet ongedaan worden gemaakt.'
      : `${count} kandidaten hebben een plek. Zij krijgen een e-mail met een excuus en een link om een andere sessie te kiezen, en hun agenda-items worden ingetrokken. Dit kan niet ongedaan worden gemaakt.`,
  liveOnboardingCancelReason: 'Reden',
  liveOnboardingCancelReasonHelp: 'Alleen voor je team. De kandidaat ziet dit nooit.',
  liveOnboardingCancelConfirm: 'Sessie annuleren',
  liveOnboardingCancelKeep: 'Laat staan',
  liveOnboardingSessionAlreadyCancelled: 'Deze sessie was al geannuleerd.',
  notSet: 'Niet ingesteld',
  screeningMethodHumanUnavailable: 'Op dit moment niet beschikbaar. Kies alsjeblieft de andere optie.',
  screeningMethodAiUnavailable: 'Niet beschikbaar voor deze functie. Kies alsjeblieft de andere optie.',
  paginationPageOf: (current: number, total: number) => `Pagina ${current} van ${total}`,
  disconnectEmailAccountModalDescription:
    'Weet je zeker dat je, je e-mail wil ontkoppelen? Als je doorgaat kan je geen e-mails meer versturen via Robin.',
  connectEmailModalDescription:
    'Koppel je persoonlijke of bedrijfsmail aan Robin om e-mails naar kandidaten te sturen!',
  theConnectionFailed: 'Koppeling niet geslaagd!',
  theConnectionFailedDescription:
    'Zorg er alsjeblieft voor dat het e-mailadres waarmee je verbindt hetzelfde is als het e-mailadres dat je gebruikt om in te loggen op Robin.',
  connectEmailDescription: (
    <span>
      Om de conversie op verzonden e-mails te verhogen moedigen wij iedereen aan je bedrijfsmail aan Robin te koppelen!{' '}
      <a href="https://help.recruitrobin.com/nl/articles/9414745-e-mail" target="_blank" rel="noreferrer">
        Lees hier meer!
      </a>
    </span>
  ),
  remindToConnectEmail: (name) => (
    <span>
      Ha {name},
      <br />
      <br />
      We veranderen van e-mail server om je deze voordelen te geven;
      <br />
      <br />
      <div css={{ paddingLeft: '1em' }}>
        1. <strong>Meer reacties van kandidaten</strong>. Mails kunnen vanaf nu met jouw eigen e-mail server worden
        verzonden, in plaats van die van ons. E-mail belanden daardoor minder vaak in spam.
      </div>
      <br />
      <div css={{ paddingLeft: '1em' }}>
        2. <strong>E-mails vind je terug in jouw mailbox</strong>. Zo weet je zeker dat e-mails zijn verzonden en kun je
        alle communicatie ook in jouw eigen e-mailbox terugvinden.
      </div>
      <br />
      <strong>Hulp nodig?</strong>
      <br />
      Je kan ons via chat het beste bereiken om de koppeling met jouw e-mail samen te maken.
    </span>
  ),
  remindToReconnectEmail: (name) => (
    <span>
      Hi {name},
      <br />
      <br />
      Door een technische fout moeten we jouw email account opnieuw koppelen.
      <br />
      Dit is nodig om via Robin emails te kunnen blijven versturen naar kandidaten.
      <br />
      <br />
      Klik op de 'Verbind opnieuw' knop hieronder en we nemen je mee in de benodigde stappen!
    </span>
  ),
  werknlProfiles: 'Werknl Bedrijfsprofielen',
  waitForTheCampaignToFullyLoad: 'Wacht tot de zoekopdracht geladen is',
  werknlIsCurrentlyDisabled: 'Werk.nl is gedeactiveerd',
  loadingCandidateCv: 'CV van kandidaat wordt geladen',
  noShortlistedCandidate: ({ onClick }) => {
    return (
      <span>
        Je hebt nog geen kandidaten 'shortlisted'. Begin door de beste kandidaten uit je zoekresultaten op{' '}
        <u onClick={onClick} css={{ cursor: 'pointer' }}>
          'shortlist'
        </u>{' '}
        te zetten.
      </span>
    );
  },
  noOtherStatusCandidate: (status) => `Je hebt nog geen kandidaten ${status}.`,
  werknlCandidateInfoPresentation: (
    <span>
      Welk{' '}
      <a href={'https://www.werk.nl/werkzoekenden/'} target="_blank" rel="noreferrer">
        Werk.nl
      </a>{' '}
      profiel heeft jouw voorkeur?
    </span>
  ),
  werknlCandidateInfoPresentationDescription:
    'We hebben de lay-out van het kandidaatprofiel gewijzigd om het beoordelen van kandidaten eenvoudiger te maken. Welke versie wil je blijven gebruiken?',
  werknlCandidateInfoPresentationNote:
    '*De keuze kan later alsnog worden gewijzigd in jouw persoonlijke profiel instellingen',
  old: 'Oud',
  confirmSelection: 'Keuze bevestigen',
  werknlLayout: 'Werk.nl lay-out',
  cvFormatIssues: 'Dit CV kan niet getoond worden vanwege problemen met het bestand.',
  disconnectVacancy: 'Ontkoppel van ATS',
  clickToActivatePlatform: (platform) => `Klik om ${platform} te activeren`,
  fromTo: (from, to) => `van ${from} naar ${to}`,
  from: 'uit',
  newCandidateAdded: 'Nieuwe kandidaat toegevoegd',
  for: 'voor',
  called: 'Gebeld',
  confirmDeleteNote: 'Weet je zeker dat je deze notitie wilt verwijderen?',
  robinResume: 'Robin Resume',
  robinResumeDescription: (atsName) => {
    if (atsName) {
      return (
        <span>
          Zet koppeling met <strong>{capitalize(atsName)}</strong> aan/uit via deze schakelaar.
        </span>
      );
    }

    return <span>Zet koppeling met het ATS aan/uit via onderstaande schakelaars.</span>;
  },
  confirmStatus: 'Opslaan',
  statusSavedWithSuccess: 'Status opgeslagen',
  syncingYourAtsStatuses: 'Koppelen met je ATS. Even geduld...',
  statusConfirmed: 'Status opgeslagen',
  statusesRefreshed: 'Statussen vernieuwd',
  checkCandidateStatuses: 'Check kandidaatstatussen',
  statusNeedToBeConfirmedForThisTenant: "Klik op 'Opslaan' om de wijzigingen op te slaan.",
  readMore: 'Lees meer',
  loginToIndeed: 'Log in op Indeed',
  indeedAssignedMessageInfo: (email) => (
    <span>
      Het Indeed Smart Sourcing abonnement <strong>{email}</strong> is nu toegewezen aan jouw Robin-account. Log in bij
      Indeed met dit e-mailadres om te startem met het benaderen van Indeed-kandidaten via Robin.
    </span>
  ),
  indeedUnassignedMessageInfo: (
    <span>
      Er is geen Indeed Smart Sourcing abonnement toegewezen aan jouw Robin-account. Neem contact op met{' '}
      <strong>de beheerder (admin) van jouw organisatie binnen Robin</strong> om een licentie aan te vragen. Lees{' '}
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        dit artikel
      </a>{' '}
      voor meer informatie.
    </span>
  ),
  indeedLicenseRequired: 'Indeed abonnement verplicht',
  indeedLicense: 'Indeed abonnement',
  isAdmin: 'Is admin',
  indeedLicensesCanBeAssigned:
    'Abonnementen kunnen maximaal 1 keer per maand worden toegewezen aan een andere gebruiker.',
  indeedSubscriptionConnectedTitle: 'Indeed abonnement gekoppeld',
  indeedSubscriptionConnectedDescription: (email) => (
    <span>
      Voor toegang tot Indeed CVs in Robin heb je vanaf 1 januari 2025 een Indeed Smart Sourcing abonnement nodig. We
      hebben het Indeed Smart Sourcing abonnement <strong>{email}</strong> gekoppeld aan jouw account in Robin.
      <br />
      <br />
      <strong>Handig om te weten</strong>
      <ul>
        <li>Je kan nu eenvoudig Indeed CVs vinden en benaderen met Robin.</li>
        <li>Één Indeed Smart Sourcing abonnement kan gekoppeld worden aan één Robin-account.</li>
        <li>Een Indeed Smart Sourcing abonnement kan eenmaal per maand worden toegekend aan een collega.</li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      Voor antwoorden op vragen klik je op 'Lees meer'.
    </span>
  ),
  noIndeedSubscriptionConnectedTitle: 'Geen Indeed abonnement gekoppeld',
  noIndeedSubscriptionConnectedDescription: (
    <span>
      Er is op dit moment geen Indeed Smart Sourcing abonnement gekoppeld aan jouw account in Robin. Voor toegang tot
      Indeed CVs in Robin heb je vanaf 1 januari 2025 een Indeed Smart Sourcing abonnement nodig.
      <br />
      <br />
      <strong>Indeed-account koppelen</strong>
      <ul>
        <li>
          <strong>Log in op Indeed: </strong>Zorg ervoor dat de{' '}
          <a href={DICTIONARY_LINKS.ROBIN_EXTENSION} target="_blank" rel="noreferrer" className="no-visited-style">
            Robin-extensie
          </a>{' '}
          actief is en log in op je Indeed-account.{' '}
        </li>
        <li>
          <strong>Indeed koppelen: </strong>Robin koppelt een actief Indeed Smart Sourcing abonnement automatisch aan
          jouw Robin-account, tenzij er geen Smart Sourcing account gekoppeld is aan jouw Indeed-account of deze al
          gekoppeld is aan het Robin-account van een collega.
        </li>
        <li>
          <strong>Bestaand abonnement gebruiken: </strong>
          <a
            href={DICTIONARY_LINKS.EXISTING_SUBSCRIPTION}
            target="_blank"
            rel="noreferrer"
            className="no-visited-style">
            lees hier
          </a>{' '}
          hoe je een Smart Sourcing abonnement kan koppelen aan jouw Robin-account, als deze nu in gebruik is door een
          collega.
        </li>
        <li>
          <strong>Abonnement kopen: </strong>
          <a href={DICTIONARY_LINKS.BUY_NEW_SUBSCRIPTION} target="_blank" rel="noreferrer" className="no-visited-style">
            Klik hier
          </a>{' '}
          als je (nog) een Indeed Smart Sourcing abonnement wilt aankopen.
        </li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        Klik hier
      </a>{' '}
      voor antwoorden op vragen en meer informatie over deze voorwaarde.
    </span>
  ),
  indeedSubscriptionAvailableTitle: 'Indeed abonnement beschikbaar',
  indeedSubscriptionAvailableDescription: (emails) => (
    <span>
      Voor toegang tot Indeed CVs in Robin heb je vanaf 1 januari 2025 een Indeed-account met Smart Sourcing abonnement
      nodig. Er zijn Indeed-account(s) met een Smart Sourcing abonnement beschikbaar voor jouw account.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>
          <strong>Log in op Indeed: </strong>Zorg ervoor dat de Robin-extensie actief is en log in op (één van deze)
          Indeed-account(s);
          <ul>
            {emails.map((email, i) => (
              <li key={i}>{email}</li>
            ))}
          </ul>
        </li>
        <li>
          <strong>Indeed koppelen: </strong>Robin koppelt een actief Indeed Smart Sourcing abonnement automatisch aan
          jouw Robin-account.
        </li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        Klik hier
      </a>{' '}
      voor antwoorden op vragen en meer informatie over deze voorwaarde.
    </span>
  ),
  noIndeedSubscriptionAvailableTitle: 'Geen Indeed abonnement beschikbaar',
  noIndeedSubscriptionAvailableDescription: (
    <span>
      Voor toegang tot Indeed CVs in Robin heb je vanaf 1 januari 2025 een Indeed Smart Sourcing abonnement nodig. Één
      Indeed Smart Sourcing abonnement kan gekoppeld worden aan één Robin-account. Op dit moment zijn alle
      Indeed-accounts met een Smart Sourcing abonnement in gebruik door collega's.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>
          <strong>Vraag toegang aan </strong>bij collega's met 'admin' rechten in Robin. Zij kunnen een Indeed Smart
          Sourcing abonnement toewijzen aan jouw account. Een Indeed Smart Sourcing abonnement kan eenmaal per maand
          worden toegekend aan een andere collega.
        </li>
        <li>
          <strong>Extra abonnement: </strong>
          <a href={DICTIONARY_LINKS.BUY_NEW_SUBSCRIPTION} target="_blank" rel="noreferrer" className="no-visited-style">
            klik hier
          </a>{' '}
          als je een Indeed Smart Sourcing abonnement wilt aankopen voor jouw Indeed-account.
        </li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      Klik op 'lees meer' voor antwoorden op vragen en meer informatie over deze voorwaarde.
    </span>
  ),
  indeedSubscriptionGrantedTitle: 'Indeed abonnement toegekend',
  indeedSubscriptionGrantedDescription: (email) => (
    <span>
      Een collega heeft het Indeed Smart Sourcing abonnement <strong>{email}</strong> toegekend aan jouw account in
      Robin. Je kan nu eenvoudig Indeed CVs vinden en benaderen met Robin.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>Log in op Indeed met het account {email}.</li>
        <li>Robin koppelt het Indeed Smart Sourcing abonnement automatisch aan jouw Robin-account.</li>
      </ul>
    </span>
  ),
  indeedSubscriptionWithdrawnTitle: 'Indeed abonnement ingetrokken',
  indeedSubscriptionWithdrawnDescription: (email) => (
    <span>
      Je hebt geen toegang meer tot Indeed CVs via Robin. Een collega heeft het Indeed Smart Sourcing abonnement{' '}
      <strong>{email}</strong> opgezegd of toegekend aan een andere collega. Op dit moment zijn er geen andere
      beschikbare Indeed Smart Sourcing abonnementen.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>
          <strong>Vraag toegang aan </strong>bij collega's met 'admin' rechten in Robin. Zij kunnen een Indeed
          abonnement toewijzen aan jouw account. Een Indeed Smart Sourcing abonnement kan eenmaal per maand worden
          toegekend aan een andere collega.
        </li>
        <li>
          <strong>Extra abonnement: </strong>Klik hier als je een Indeed Smart Sourcing abonnement wilt aankopen voor
          jouw Indeed-account.
        </li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      Klik op 'lees meer' voor antwoorden op vragen.
    </span>
  ),
  indeedSubscriptionWithdrawnSubscriptionAvailableTitle: 'Indeed abonnement ingetrokken',
  indeedSubscriptionWithdrawnSubscriptionAvailableDescription: (email, emails) => (
    <span>
      Je hebt geen toegang meer tot Indeed CVs via Robin. Een collega heeft het Indeed Smart Sourcing abonnement{' '}
      <strong>{email}</strong> opgezegd of toegekend aan een andere collega. Er zijn nog andere Indeed Smart Sourcing
      abonnement(en) beschikbaar voor jouw account.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>
          <strong>Log in op Indeed: </strong>Zorg ervoor dat de Robin-extensie actief is en log in op (één van deze)
          Indeed-account(s);
          <ul>
            {emails.map((email, i) => (
              <li key={i}>{email}</li>
            ))}
          </ul>
        </li>
        <li>
          <strong>Indeed koppelen: </strong>Robin koppelt een actief Indeed Smart Sourcing abonnement automatisch aan
          jouw Robin-account.
        </li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        Klik hier
      </a>{' '}
      voor antwoorden op vragen.
    </span>
  ),
  indeedSubscriptionExpiredWithAvailableTitle: 'Indeed abonnement is verlopen',
  indeedSubscriptionExpiredWithAvailableDescription: (emails) => (
    <span>
      Het Indeed-account waarmee je probeerde in te loggen heeft geen actief Smart Sourcing-abonnement. Voor toegang tot
      alle Indeed CVs via Robin, heb je een Indeed-account nodig met een actief Indeed Smart Sourcing-abonnement.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>
          <strong>Log in op een Indeed-account </strong>met een actief Smart Sourcing-abonnement:
          <ul>
            {emails.map((email, i) => (
              <li key={i}>{email}</li>
            ))}
          </ul>
        </li>
        <li>
          <strong>Indeed koppelen: </strong>Robin verbindt automatisch een actief Indeed Smart Sourcing-abonnement met
          jouw Robin-account, zodra je bent ingelogd in Indeed.
        </li>
      </ul>
    </span>
  ),
  indeedSubscriptionExpiredTitle: 'Indeed abonnement is verlopen',
  indeedSubscriptionExpiredDescription: (
    <span>
      Het Indeed-account waarmee je probeerde in te loggen heeft geen actief Smart Sourcing-abonnement. Voor toegang tot
      alle Indeed CVs via Robin, heb je een Indeed-account nodig met een actief Indeed Smart Sourcing-abonnement.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>
          <strong>Bestaand abonnement gebruiken: </strong>vraag toegang aan collega's met 'admin'-rechten in Robin om
          een ander Indeed Smart Sourcing-abonnement te koppelen aan jouw Robin-account, indien beschikbaar. Daarna,
          login op Indeed met het e-mailadres dat is gekoppeld aan het Indeed Smart Sourcing-abonnement.
        </li>
        <li>
          <strong>Abonnement kopen: </strong>
          <a href={DICTIONARY_LINKS.BUY_NEW_SUBSCRIPTION} target="_blank" rel="noreferrer" className="no-visited-style">
            klik hier
          </a>{' '}
          als je een Indeed Smart Sourcing-abonnement wilt kopen voor jouw huidige Indeed-account.
        </li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      Voor antwoorden op vragen klik je op 'Lees meer'.
    </span>
  ),
  indeedSubscriptionConnectedAdminTitle: 'Indeed abonnement toegewezen',
  indeedSubscriptionConnectedAdminDescription: (email) => (
    <span>
      Voor toegang tot Indeed CVs in Robin heb je vanaf 1 januari 2025 een Indeed Smart Sourcing abonnement nodig. We
      hebben het Indeed Smart Sourcing abonnement <strong>{email}</strong> gekoppeld aan jouw account in Robin.
      <br />
      <br />
      <strong>Indeed abonnementen toewijzen</strong>
      <br />
      Je bent 'admin' van Robin en kan Indeed Smart Sourcing abonnementen toewijzen aan collega's.
      <br />
      <br />
      <ul>
        <li>Smart Sourcing Abonnement(en) toewijzen aan collega's kan in het hoofdmenu bij 'gebruikers'.</li>
        <li>Één Indeed Smart Sourcing abonnement kan gekoppeld worden aan één Robin-account.</li>
        <li>Een Indeed Smart Sourcing abonnement kan eenmaal per maand worden toegekend aan een andere collega.</li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      Voor antwoorden op vragen klik je op 'Lees meer'.
    </span>
  ),
  noIndeedSubscriptionConnectedAdminTitle: 'Geen Indeed abonnement gekoppeld',
  noIndeedSubscriptionConnectedAdminDescription: (
    <span>
      Er is op dit moment geen Indeed Smart Sourcing abonnement gekoppeld aan jouw Robin-account, of die van collega's.
      Voor toegang tot Indeed CVs in Robin heb je vanaf 1 januari 2025 een Indeed Smart Sourcing abonnement nodig.
      <br />
      <br />
      <strong>Indeed abonnementen toewijzen</strong>
      <br />
      Als 'admin' van Robin kun je Indeed Smart Sourcing abonnementen toewijzen aan het Robin-account van jezelf en
      collega's.
      <br />
      <br />
      <ul>
        <li>
          <strong>Log in op Indeed: </strong>Zorg ervoor dat de Robin-extensie actief is en log in op je Indeed-account.{' '}
        </li>
        <li>
          <strong>Indeed koppelen: </strong>Robin koppelt een actief Indeed Smart Sourcing abonnement automatisch aan
          jouw Robin-account, tenzij deze al gekoppeld is aan het account van een collega.
        </li>
        <li>
          <strong>Abonnement(en) toewijzen aan collega's: </strong>Dat kan in het hoofdmenu bij 'gebruikers'.
        </li>
      </ul>
      <strong>Meer weten?</strong>
      <br />
      <a href={DICTIONARY_LINKS.INDEED_KNOW_MORE} target="_blank" rel="noreferrer" className="no-visited-style">
        Klik hier
      </a>{' '}
      voor antwoorden op vragen en meer informatie over deze voorwaarde.
    </span>
  ),
  noIndeedActiveSubscriptionWithAvailableTitle: 'Geen actief Indeed abonnement',
  noIndeedActiveSubscriptionWithAvailableDescription: (email, emails) => (
    <span>
      Er is geen Indeed Smart Sourcing abonnement gekoppeld aan jouw Indeed-account <strong>{email}</strong>. Voor
      toegang tot alle Indeed CVs via Robin, heb je een Indeed-account nodig met een actief Indeed Smart
      Sourcing-abonnement.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>
          <strong>Log in </strong>op een Indeed-account met een actief Smart Sourcing-abonnement:
          <ul>
            {emails.map((email, i) => (
              <li key={i}>{email}</li>
            ))}
          </ul>
        </li>
        <li>
          <strong>Indeed koppelen: </strong>Robin koppelt een actief Indeed Smart Sourcing abonnement automatisch aan
          jouw Robin-account.
        </li>
      </ul>
    </span>
  ),
  noIndeedActiveSubscriptionTitle: 'Geen actief Indeed abonnement',
  noIndeedActiveSubscriptionDescription: (email) => (
    <span>
      Er is geen Indeed Smart Sourcing abonnement gekoppeld aan jouw Indeed-account <strong>{email}</strong>. Voor
      toegang tot alle Indeed CVs via Robin, heb je een Indeed-account nodig met een actief Indeed Smart
      Sourcing-abonnement.
      <br />
      <br />
      <strong>Indeed abonnement koppelen</strong>
      <ul>
        <li>
          <strong>Ander Indeed-account gebruiken: </strong>heeft je organisatie al een Indeed Smart Sourcing abonnement
          dat is gekoppeld aan een ander Indeed-account?{' '}
          <a
            href={DICTIONARY_LINKS.EXISTING_SUBSCRIPTION}
            target="_blank"
            rel="noreferrer"
            className="no-visited-style">
            Lees hier
          </a>{' '}
          hoe je een ander Indeed-account kan koppelen aan jouw Robin-account en wat je kan doen als deze nu in gebruik
          is door een collega.
        </li>
        <li>
          <strong>Abonnement kopen: </strong>
          <a href={DICTIONARY_LINKS.BUY_NEW_SUBSCRIPTION} target="_blank" rel="noreferrer" className="no-visited-style">
            Klik hier
          </a>{' '}
          als je nog geen Indeed Smart Sourcing abonnement hebt en er één wilt aankopen.
        </li>
      </ul>
    </span>
  ),
  unassignLicense: 'Licentie verwijderen',
  robinResumeDashboardDescription: 'Het aantal CVs dat je hebt gedeeld en de acties door recruiters met jouw CVs.',
  totalNumberOfCvs: 'Totaal aantal zichtbare CVs',
  startsWith: 'Begint met',
  contains: 'Bevat',
  endsWith: 'Eindigt met',
  selectAnAtsVacancy: 'Selecteer een ATS vacature',
  selectJobImprovedModalSubtitle: 'Kies een vacature om de kandidaat naar je ATS te sturen.',
  selectJobModalInsufficientJobInfo:
    'Deze vacature bevat niet genoeg informatie om Robin Jr. te starten. Je kunt de vacaturetekst aanvullen of een andere vacature kiezen om door te gaan.',
  selectJobModalIntroMessage: (
    <>
      Om Robin Jr. te gebruiken en je eerste outreach en opvolging te automatiseren, moet je eerst een vacature
      selecteren. Zo kunnen we de communicatie goed afstemmen.
      <br />
      <br />
      Selecteer een bestaande vacature of maak een nieuwe aan om door te gaan:
    </>
  ),
  selectAtsVacancyFirst: (candidateFirstName: string, atsName: string) =>
    `Voeg ${candidateFirstName} toe aan ${atsName}`,
  selectAtsVacancyRobinJr: (candidateFirstName: string, atsName: string) =>
    `Kies een vacature in ${atsName}. Wij sturen ${candidateFirstName} er meteen naartoe naar ${atsName}.`,
  selectAtsVacancyForMatching: (candidateFirstName: string, atsName: string) =>
    `Kies een vacature uit ${atsName}. Wanneer ${candidateFirstName} naar match wordt verplaatst, voegen we ze automatisch toe aan ${atsName}.`,
  skipAndMatch: 'Overslaan & matchen',
  matchAndPushToAts: 'Matchen & naar ATS pushen',
  skipAndSendMessage: 'Overslaan & bericht versturen',
  sendAndPushToAts: 'Versturen & naar ATS pushen',
  selectAtsVacancyForScheduling: (candidateFirstName: string, atsName: string) =>
    `Kies een vacature in ${atsName}. Wanneer je een interview plant voor ${candidateFirstName}, synchroniseren we dit met ${atsName}.`,
  skipAndSchedule: 'Overslaan & planner openen',
  connectAndSchedule: 'Koppelen & planner openen',
  theCandidate: 'de kandidaat',
  yourAts: 'jouw ATS',
  insufficientInfoRobinJr:
    'Onvoldoende informatie in de geselecteerde vacature. Vul de vacature in je ATS aan of selecteer een andere om hulp te krijgen van Robin Jr.',
  enabledRobinJrFollowUpTitle: 'Automatisch opvolgen',
  enabledRobinJrFollowUpDescription:
    'De kandidaat krijgt tot twee extra berichten om de kans op reactie te vergroten. Het eerste na twee dagen.',
  disableRobinJrFollowUpTitle: 'Opvolgen uitzetten?',
  disableRobinJrFollowUpDescription:
    'Als je doorgaat, wordt er geen opvolgingsbericht verstuurd of ingepland. Je kunt dan handmatig een opvolgingsbericht sturen.',
  yesCancelIt: 'Ja, zet uit',
  candidateContactedViaEmail: 'Deze kandidaat is eerder benaderd via e-mail',
  read: 'Lees',
  indeedAttemptRetrying: 'Opnieuw proberen',
  indeedAttemptsCount: (attemptsCount) => `${attemptsCount} ${attemptsCount === 1 ? 'poging' : 'pogingen'}`,
  indeedAttemptNotDelivered: 'Niet afgeleverd',
  indeedAttemptNotSent: 'Niet verzonden',
  indeedAttemptDelivered: 'Afgeleverd',
  indeedFailureAlreadyContacted: (candidateName) =>
    `${candidateName} is al benaderd via Indeed, dus dit bericht is niet verstuurd.`,
  indeedFailureRecentlyDeclined: (candidateName) =>
    `${candidateName} heeft recent een uitnodiging via Indeed afgewezen, dus kan daar nu niet worden benaderd.`,
  indeedFailureSubscriptionMismatch:
    'Dit Indeed-account kan geen kandidaten voor deze vacature berichten. De vacature en de licentie horen bij verschillende abonnementen.',
  indeedFailureGeneric: 'Indeed kon dit bericht niet afleveren.',
  indeedFailureLastTried: (timeAgo) => `Laatst geprobeerd ${timeAgo}.`,
  indeedFailureRetry: 'Opnieuw proberen',
  indeedFailureRetrying: 'Opnieuw proberen…',
  emailFollowUpPlanned: 'E-mail opvolging gepland',
  cancelFollowUp: 'Annuleer opvolging',
  robinJr: 'Robin Jr.',
  boostReplies: 'Voeg vacature toe en boost reacties met 70%',
  letsTryIt: 'Probeer nu!',
  reachoutConversion: 'Conversie contactmomenten',
  conversionOfAllChannels: 'Conversie van alle AI-contactkanalen',
  conversations: 'Gesprekken',
  conversion: 'Conversie',
  weAreGeneratingAiMessage: 'We schrijven een bericht op maat, op basis van het CV en jouw vacature.',
  candidatesContacted: 'Benaderd',
  responded: 'Reacties',
  replied: 'Gereageerd',
  manualReachOut: 'Door recruiters',
  aiReachOut: 'Door AI',
  matchedByColleague: 'Gematcht, door mij of collega',
  contactedByColleague: 'Gecontacteerd, door mij of collega',
  hiddenByMe: 'Verborgen, door mij',
  createNewJob: 'Vacature toevoegen',
  addJob: 'Voeg vacature toe',
  jobDescription: 'Functieomschrijving',
  editCustomJob: 'Aangepaste vacature bewerken',
  disconnectJob: 'Vacature ontkoppelen',
  callOutcome: 'Uitkomst telefoongesprek',
  selectLabel: 'Selecteer een label',
  theLabelSelectionIsRequired: 'De selectie van een label is verplicht',
  // Handmatig benadert / Benadert door AI - Handmatig contact / Contact door AI

  // Central Inbox
  inbox: 'Inbox',
  emptyConversations: 'Je inbox is leeg!',
  addNote: 'Notitie toevoegen',
  takeNote: 'Maak een notitie',
  all: 'Alles',
  unread: 'Ongelezen',
  sent: 'Verzonden',
  openInInbox: 'Openen in inbox',
  switchAnyway: 'Toch wisselen',
  stayOnCurrentChannel: 'Blijf op huidig kanaal',
  switchChannelsTitle: 'Je invoer gaat verloren bij het wisselen van kanaal',
  switchChannelsContent:
    'Als je naar een ander kanaal gaat, wordt de ingevoerde tekst niet opgeslagen. Weet je zeker dat je door wilt gaan?',
  inboxEmailConnected: 'E-mailkanaal is verbonden',
  inboxEmailDisconnected: 'Klik om e-mailkanaal te verbinden',
  inboxWhatsappConnected: 'Het WhatsApp-kanaal voor het verzenden van berichten is actief.',
  inboxWhatsappDisconnected: 'WhatsApp-kanaal is niet verbonden',
  inboxLinkedinConnected: 'LinkedIn-kanaal is verbonden',
  inboxLinkedinDisconnected: 'Klik om LinkedIn-kanaal te verbinden',
  inboxLinkedinInmailConnected: 'LinkedIn InMail-kanaal is verbonden',
  inboxLinkedinInmailDisconnected: 'Klik om LinkedIn InMail-kanaal te verbinden',
  inboxIndeedConnected: 'Indeed-kanaal is verbonden',
  inboxIndeedDisconnected: 'Klik om Indeed-kanaal te verbinden',
  inboxRjCommunicationHubConnected: 'RJ Communication Hub is verbonden',
  inboxRjCommunicationHubDisconnected: 'RJ Communication Hub niet verbonden',

  // vacancy creation/enriching
  removeEnrichedVersion: 'Bewerkte Versie Verwijderen',
  jobPreview: 'Job preview',
  jobDetails: 'Vacature',
  viewOnIndeed: 'Bekijk op Indeed',
  updatingJobPreview: 'Updaten op basis van je laatste wijzigingen...',
  visibleToCandidatesAsAttachment: 'Zichtbaar voor kandidaten als bijlage.',
  theJobPreviewHasBeenCopied: 'De job preview is gekopieerd',
  employmentRequirements: 'Werkafspraken',
  workingHoursRange: 'Werkuren (range)',
  jobRequirements: 'Functievereisten',
  minimumEducationLevel: 'Minimaal opleidingsniveau',
  languagesLabel: 'Talenkennis',
  driversLicense: 'Rijbewijs',
  tasks: 'Taken',
  keyTasks: 'Hoofdtaken',
  atsNotConnected: 'ATS niet gekoppeld',
  atsNotConnectedDescription: (
    <span>
      We kunnen geen vacatures tonen omdat je ATS niet is gekoppeld.{' '}
      <a href="https://help.recruitrobin.com/nl/" target="_blank" rel="noopener noreferrer">
        Klik hier
      </a>{' '}
      om je ATS te koppelen.
    </span>
  ),
  manageYourJobs: 'Beheer je vacatures',
  saveAndSubmit: 'Opslaan',
  atsContentWarning: 'De ATS-versie kun je alleen in je ATS aanpassen',
  enrichedVersion: 'Bewerkte versie',
  removeEnrichedVersionDescription:
    'Als je deze versie verwijdert, blijft het origineel (ATS) zichtbaar. Dit kan niet ongedaan worden gemaakt.',
  yesRemoveIt: 'Ja, verwijderen',
  selectTemplate: 'Gebruik sjabloon',
  createAJob: 'Vacature toevoegen',
  enrichVacancyChooseMethod: 'Kies een optie om te beginnen',
  provideText: 'Tekst invoeren',
  uploadFile: 'Bestand toevoegen (PDF of Word)',
  lowReplyChance: 'Lage kans op reactie',
  mediumReplyChance: 'Gemiddelde kans op reactie',
  highReplyChance: 'Hoge kans op reactie',
  insufficientInfo: 'Onvoldoende informatie',
  sufficientInfo: 'Voldoende informatie',
  letsImproveIt: 'Details toevoegen',
  checkInfo: 'Bekijk details',
  secondaryBenefits: 'Secundaire voorwaarden',
  atsVersion: 'ATS-vacature',
  applicationDeadline: 'Sollicitatiedeadline',
  salaryUnit: 'Salaris eenheid',
  workdays: 'Werkdagen',
  shifts: 'Diensten',
  workAddress: 'Werklocatie(s)',
  radiusKm: 'Radius (km)',
  positionOverview: 'Functieomschrijving',
  goodStatus: 'Goed',
  hourly: 'per uur',
  monthly: 'per maand',
  weekly: 'per week',
  yearly: 'per jaar',
  allWorkDays: 'Alle werkdagen',
  monday: 'Maandag',
  tuesday: 'Dinsdag',
  wednesday: 'Woensdag',
  thursday: 'Donderdag',
  friday: 'Vrijdag',
  saturday: 'Zaterdag',
  sunday: 'Zondag',
  shiftDay: 'Dagdienst',
  shiftEvening: 'Avonddienst',
  shiftNight: 'Nachtdienst',
  shift2Cycle: '2 ploegen dienst',
  shift3Cycle: '3 ploegen dienst',
  shift4Cycle: '4 ploegen dienst',
  shift5Cycle: '5 ploegen dienst',
  thinking: 'Even denken...',
  improveWithAI: 'Verbeter met AI',

  level: 'Niveau',
  fullTime: 'Fulltime',
  partTime: 'Parttime',
  reviewingYourVacancyForQuality: 'Vacature controleren op kwaliteit...',
  thisFieldIsRequiredError: 'Dit veld is vereist',
  pleaseSelectAValidLocation: 'Selecteer een locatie uit de suggesties',
  editVacancy: 'Vacature bewerken',
  enrichVacancy: 'Vacature verrijken',
  addDetailsOrSelectAnotherJob: 'Voeg details toe of kies een andere vacature.',
  robinJrSuggestions: 'Robin JR. suggesties:',
  insert: 'Invoegen',
  pasteJobDescription: 'Plak vacaturetekst',
  lowQuality: 'Lage kwaliteit',
  mediumQuality: 'Gemiddelde kwaliteit',
  highQuality: 'Hoge kwaliteit',
  noVacanciesFound: 'Geen vacatures gevonden',
  checkYourAtsConnection: 'Controleer je ATS-verbinding',
  learnMore: 'Meer informatie',
  learnMoreLink: 'https://help.recruitrobin.com/nl/',
  youCanAlso: 'Je kunt ook',
  inRobin: 'in Robin',
  saveJobRequiredFields: 'Je kunt deze vacature alleen opslaan als alle verplichte velden zijn ingevuld',
  searchVacancy: 'Zoek vacature',
  theIndeedContentHasBeenCopied: 'De Indeed-inhoud is gekopieerd',
  theAtsContentHasBeenCopied: 'De ATS-inhoud is gekopieerd',
  errorProcessingVacancyFile: (
    <span>
      We konden het geselecteerde bestand niet lezen. <br />
      Controleer of het een geldig PDF- of Word-bestand is en probeer het opnieuw.
    </span>
  ),
  atsDisconnected: 'ATS ontkoppeld',
  addDetailsAndIncreaseYourChanceToGetAReply: (
    <span>
      Voeg details toe en vergroot je
      <br />
      reactiekans.
    </span>
  ),
  jobDescriptionComplete: (
    <span>
      De vacature is compleet.
      <br />
      Goed gedaan!
    </span>
  ),
  improveGeneratedMessage: 'Verbeter gegenereerd bericht',
  couldNotCreateMessageDueToInsufficientData:
    'We konden het bericht niet maken omdat de ATS-vacature die je hebt geselecteerd niet genoeg gegevens bevat. Wil je het nu verbeteren?',
  messageGeneratedButCouldBeStronger:
    'We hebben een bericht gegenereerd, maar extra details kunnen het sterker maken. Wil je het verbeteren?',

  // vacancy creation/enriching placeholders form
  minimumEducationLevelPlaceholder: 'bijv. MBO',
  languagesPlaceholder: 'bijv. Engels, Nederlands',
  address: 'Adres',
  workAddressPlaceholder: 'bijv. 3526 KS, Utrecht of Utrecht en Eindhoven',
  phonePlaceholder: 'bijv. +31 0645536273',
  salaryRangePlaceholder: 'bijv. €3,000',
  salaryRangePlaceholderMax: 'bijv. €4,000',
  workingHoursRangePlaceholder: 'bijv. 40 - 50 uur',
  shiftPlaceholder: 'bijv. Dagdienst',
  workdaysPlaceholder: 'bijv. Maandag - Vrijdag',
  certificationsPlaceholder: 'bijv. Heftruckcertificaat',
  commuteByCar: 'Met de auto',
  commyteByBike: 'Met de fiets',
  bestMatch: 'Beste match',

  checkYourPhone: 'Check je telefoon',
  phoneNotConnected: 'Telefoon niet verbonden',
  connectYourMobileToRobin: 'Verbind je mobiel met Robin',
  connectYourMobileToRobinDescription: (
    <span>
      Zo doe je dat:
      <ul>
        <li>Download de Robin app (Recruit Robin) in Apple store / Google play.</li>
        <li>Log in met je Robin-gegevens.</li>
        <li>Ververs deze pagina. Klaar! Je telefoon is gekoppeld.</li>
      </ul>
      Hulp nodig? Mail naar{' '}
      <a href="mailto:support@recruitrobin.com" target="_blank" rel="noopener noreferrer" className="default-link">
        support@recruitrobin.com
      </a>{' '}
      of start een chat.
    </span>
  ),
  gotIt: 'Check!',

  moreJobDetailsNeeded: 'Meer vacaturegegevens nodig om bericht te genereren',
  errorProcessingVacancy: 'We konden de vacaturegegevens niet verwerken',
  errorProcessingAtsVacancy:
    'We konden de vacaturegegevens van het ATS niet verwerken.\nControleer de originele bron of vul de gegevens handmatig in.',
  youCannotImproveAlreadyImprovedVacancy: 'Je kunt een verbeterde vacature niet opnieuw verbeteren',
  /* ---- start: added by AI ---- */
  failedToProcessAtsVacancyMissing: ({ missingFields }: { missingFields: string }) =>
    `Kon ATS-vacature niet verwerken. Ontbrekend: ${missingFields}.`,
  /* ---- end: added by AI ---- */

  alwaysShowAlternativeChannels: 'Altijd alternatieve kanalen tonen',
  alternativeChannels: 'Alternatieve kanalen',
  alternativeChannelsDescription: 'Wil je een andere manier proberen om te bereiken?',
  dontShowThisNextTime: 'Niet meer tonen',
  sendWhatsApp: 'Verstuur WhatsApp',
  sendWerknl: 'Verstuur werk.nl',
  sendLinkedin: 'Verstuur LinkedIn',
  sendIndeed: 'Verstuur Indeed',
  connectWithCandidateLinkedin: (candidateName) => `Connect met ${candidateName} op LinkedIn`,
  messageCandidateLinkedin: (candidateName) => `Stuur ${candidateName} een bericht op LinkedIn`,
  indeedJob: 'Indeed vacature',
  indeedJobs: 'Indeed vacatures',
  atsJobs: 'ATS vacatures',

  /* ---- start: added by AI ---- */
  processing: 'Verwerken...',
  processJob: 'Verwerk vacature',
  minWorkingHours: 'Minimale werkuren',
  maxWorkingHours: 'Maximale werkuren',
  minWorkingHoursPlaceholder: 'bijv. 40',
  maxWorkingHoursPlaceholder: 'bijv. 50',
  employmentTypeTemporaryAgencyWork: 'Uitzenden',
  activateRobinJrTitle: 'Activeer Robin Jr.',
  activateRobinJrDescription: (
    <>
      We personaliseren berichten op basis van je functiebeschrijving en laten deze aan kandidaten zien om het aantal
      reacties te verhogen
      <br />
      <br />
      Bevestig alsjeblieft dat dit de juiste baan is voordat je begint
    </>
  ),
  activateRobinJrIndeedDescription: (
    <>
      We personaliseren berichten op basis van je functiebeschrijving en laten deze aan kandidaten zien om het aantal
      reacties te verhogen.
      <br />
      Bevestig alsjeblieft dat dit de juiste baan en het juiste Indeed-project zijn voordat je begint:
    </>
  ),
  reactivateRobinJrTitle: 'Robin Jr. heractiveren',
  reactivateRobinJrDescription: (
    <span>
      Robin Jr. was laatst actief op de <b>"Verstuur reach out"</b> fase.
      <br />
      Daarna zal het <b>"Verstuur eerste opvolging"</b> volgen op basis van je instellingen.
    </span>
  ),
  activateRobinJrTrackProgress: 'Volg de voortgang in het Activiteitentabblad en ontvang e-mailupdates',
  getStarted: 'Beginnen',
  robinJrIsAnalysingYourVacancy: 'Robin Jr. analyseert je vacature',
  startingRobinJr: 'Robin Jr. wordt gestart...',
  areYouSureToPauseRobinJr: 'Weet je zeker dat je Robin Jr. wilt pauzeren?',
  robinJrIsCurrentlyDescription: (currentAction: string) => (
    <>
      Robin Jr. is momenteel <strong>{currentAction}</strong>. Als je nu pauzeert, moet je deze taken zelf overnemen.
      Weet je zeker dat je wilt stoppen?
    </>
  ),
  robinJrIndeedPauseDescription: (
    <>
      Robin Jr. is <strong>aan het wachten tot de kandidaat interesse bevestigt</strong>. Als je pauzeert, gaat Robin
      Jr. niet verder met de communicatie-opvolgingen en plant Robin Jr. geen interview wanneer de kandidaat reageert.
      Je moet het vanaf hier zelf overnemen.
    </>
  ),
  yesStopIt: 'Ja, pauzeren',
  communicationEnded: 'Communicatie beëindigd',
  reachingOutCandidate: 'Kandidaat benaderen',
  rjCommHubIndeedWaitingForReply: 'Wachten op Indeed-reactie',
  rjCommHubIndeedWaitingForEmailAddress: 'Wachten op e-mailadres',
  sentFirstFollowUp: 'Eerste opvolging verstuurd',
  sentSecondFollowUp: 'Tweede opvolging verstuurd',
  robinJrActive: 'Robin jr. actief',
  goodNewsCandidate: (candidateName: string, jobTitle: string, vefiedInfo?: React.ReactNode) => (
    <span>
      Goed nieuws!
      <br />
      {candidateName} heeft interesse getoond in je vacature voor de functie {jobTitle}.
      {vefiedInfo && (
        <>
          <br />
          De kandidaat heeft ook aanvullende details gedeeld:
          <br />
          <br />
          {vefiedInfo}
        </>
      )}
      <br />
      <br />
      Neem direct contact op met de kandidaat via <b>telefoon</b> of <b>e-mail</b> om de volgende stappen te bespreken.
    </span>
  ),
  candidateNotInterested: (candidateName: string, jobTitle: string) => (
    <span>
      We wilden je laten weten dat {candidateName} geen interesse heeft in de {jobTitle} functie die je hebt aangeboden.
    </span>
  ),
  didntReceiveResponse:
    'We hebben geen reactie ontvangen van de kandidaat na 2 opvolgings-berichten en 14 dagen. Het profiel is gemarkeerd als verborgen om je pipeline schoon te houden en de opvolging is beëindigd.',
  companyIsHiring: (params) => {
    const parts = [params.jobTitle, params.salaryRange, params.city].filter(Boolean);
    return parts.join(' | ');
  },
  loadingVacancyDetails: 'Vacaturegegevens laden...',
  vacancyPreviewUnavailable: 'Geen omschrijving beschikbaar',
  vacancyPreviewError: 'Omschrijving kon niet worden geladen',
  errorLoadingVacancy: (error: string) => `Fout bij het laden van vacature: ${error}`,
  vacancyNotFound: 'Vacature niet gevonden',
  aboutTheRole: 'Over de functie',
  yourResponsibilities: 'Jouw verantwoordelijkheden',
  whatWeOffer: 'Wat wij bieden',
  certificatesLabel: 'Certificaten',
  driversLicenseLabel: 'Rijbewijs',
  interestedInOpportunity: 'Interesse in deze kans? We brengen je direct in contact met de recruiter.',
  yesPlease: 'Ja, graag',
  noThanks: 'Nee, bedankt',
  questionsEmailUs: 'Vragen? Mail ons op',
  poweredBy: 'Mogelijk gemaakt door',
  emailFooterDoNotReply: 'Beantwoord deze e-mail niet. Uw reactie komt niet bij de werkgever terecht.',
  emailFooterRobinProcesses: 'Robin verwerkt en analyseert uw activiteit in deze e-mail. AI-ondersteund bericht.',
  emailFooterUnsubscribe: 'Uitschrijven',
  emailFooterPrivacyPolicy: 'Privacyverklaring',
  robinJrBrandingTitle: 'Robin junior huisstijl',
  robinJrBrandingSubtitle: 'Pas uw automatische e-mails aan via de communicatieagent-sjablonen van Rj',
  robinJrBrandingUploadLogo: 'Upload uw logo',
  robinJrBrandingUploadHint: 'PNG, JPG of JPEG',
  robinJrBrandingUploadMaxSize: 'Max. grootte 1 MB',
  robinJrBrandingSelectColorFromScreen: 'Kies je scherm kleur',
  robinJrBrandingSaveTemplate: 'Sjabloon opslaan',
  robinJrBrandingSaving: 'Opslaan...',
  robinJrBrandingShowPreview: 'Voorbeeld weergeven',
  robinJrBrandingPleaseUploadLogo: 'Upload eerst een logo voordat u opslaat',
  robinJrBrandingInvalidFileType: 'Alleen PNG, JPG of JPEG bestanden zijn toegestaan',
  robinJrBrandingFileTooLarge: 'Bestandsgrootte moet kleiner zijn dan 1 MB',
  robinJrBrandingSavedSuccessfully: 'Huisstijl succesvol opgeslagen',
  robinJrBrandingSaveFailed: 'Opslaan van huisstijl mislukt',
  robinJrBrandingOrganisation: 'Organisatie',
  robinJrBrandingLoadFailed: 'Laden van huisstijl mislukt',
  robinJrBrandingDefaultBadge: 'Standaard',
  robinJrBrandingSetAsDefault: 'Instellen als standaard',
  robinJrBrandingSetAsDefaultSuccess: 'Standaard huisstijl bijgewerkt',
  robinJrBrandingSetAsDefaultFailed: 'Bijwerken van standaard huisstijl mislukt',
  robinJrBrandingEyedropperNotSupported: 'Kleurenkiezer wordt niet ondersteund in deze browser',
  robinJrBrandingReset: 'Resetten',
  robinJrBrandingResetting: 'Resetten...',
  robinJrBrandingResetConfirmTitle: 'Huisstijl resetten',
  robinJrBrandingResetConfirmDescription:
    'Hiermee verwijder je jullie eigen logo en kleur. Je huisstijl springt dan direct weer terug naar onze standaardinstellingen.',
  robinJrBrandingResetSuccessfully: 'Huisstijl succesvol gereset',
  robinJrBrandingResetFailed: 'Resetten van huisstijl mislukt',
  cantUseRobinJrUnsubscribed: (
    <span>
      Je kunt Robin Jr niet gebruiken omdat
      <br />
      de gebruiker zich heeft afgemeld voor e-mail bereik
    </span>
  ),
  clickToActivateRobinJr: 'Klik om Robin Jr. te activeren',
  indeedNoVacancySelected: 'Selecteer een vacature om door te gaan',
  thanksForYourInterest: 'Bedankt voor je interesse!',
  thanksForYourResponse: 'Bedankt voor je reactie!',
  recruiterWillReachOutSoon:
    'Een recruiter neemt snel contact met je op. Wil je intussen meer vacatures zoals deze ontvangen?',
  strictlyRequiredForThisJob: 'Strikt vereist voor deze functie',
  byConfirmingYouAgreeToShare:
    'Door te bevestigen, stem je ermee in om je profiel te delen met geverifieerde recruiters om gekoppeld te worden aan relevante kansen.',
  anyFeedbackOptional: 'Feedback? (Optioneel)',
  helpUsImproveJobRecommendations: 'Help ons onze vacature-aanbevelingen te verbeteren...',
  confirmAndStart: 'Bevestigen en starten',
  confirmAndNext: 'Bevestigen en volgende',
  sendIndeedMessage: 'Verstuur Indeed-bericht',
  indeedCreditsRemainingPrefix: 'Je hebt',
  indeedCreditsLabel: (credits) => `${credits} CREDITS`,
  indeedCreditsRemainingSuffix: 'over in je Indeed-account.',
  indeedJobNotHighQuality: 'Deze vacature heeft geen Hoge Kwaliteit.',
  editAndEnhanceJob: 'Pas de vacature aan en verbeter deze',
  toActivateRobinJr: 'om Robin Jr. te activeren.',
  reviewQualificationQuestionary: 'Selectievragen',
  loadingQualificationQuestionary: (
    <>
      Selectievragen worden aangemaakt
      <br />
      dit duurt een paar seconden
    </>
  ),
  pleaseReviewTheQualificationQuestions: ' Geef per vraag aan of het echt nodig is, of mooi meegenomen.',
  jobUpdatedReviewRequired: (
    <>
      <b>Vacature bijgewerkt! </b>
    </>
  ),
  autoSendInterviewInviteTitle: 'Automatisch interviewuitnodiging verzenden',
  autoSendInterviewInvite: (
    <>
      Verstuur automatisch een interviewuitnodiging naar kandidaten die{' '}
      <strong>aan alle vereiste criteria voldoen.</strong>
    </>
  ),
  dontShowQualificationQuestionaryPreviewNextTime: (
    <>
      Toon de preview van de <strong>kwalificatievragenlijst</strong> de volgende keer niet.
    </>
  ),
  reviewOutreachMessage: 'Beoordeel outreachberichten',
  reviewOutreachMessageDescription:
    'Controleer het eerste bericht en bevestig het voordat we het outreach-proces starten',
  robinJrBulkPersonalisingReviewBeforeSend: 'Robin Jr. personaliseert elk bericht · controleer voor verzending',
  robinJrBulkReachingOutToEachCandidate: 'Robin Jr. benadert elke kandidaat',
  checkRobinBoxForReplies: 'Controleer Robin-box op reacties',
  checkRobinBox: 'Controleer Robin-box',
  confirmRemoveBulkCandidate: (name) => `${name} uit de lijst verwijderen? Rj zal hen niet benaderen.`,
  sendingMessages: 'Berichten versturen...',
  bulkAllMessagesSent: 'Alle berichten verstuurd',
  bulkSomeMessagesCouldNotBeSent: 'Sommige berichten konden niet worden verstuurd',
  sentProgress: (sent, total) => `${sent} van ${total} verstuurd`,
  previewAsCandidate: 'Bekijk als kandidaat',
  regenerateMessage: 'Bericht opnieuw genereren',
  bulkGenerating: 'Genereren...',
  bulkAllMessagesReady: 'Alle berichten klaar',
  bulkAllMessagesReadyReviewBeforeSend: 'Alle berichten klaar · controleer voor verzending',
  bulkSomeMessagesCouldNotBeGeneratedReviewBeforeSend:
    'Sommige berichten konden niet worden gegenereerd · controleer voor verzending',
  bulkNFailed: (n) => `${n} mislukt`,
  bulkGenerationDoneWithFailures: (n) => `${n} berichten mislukt · overslaan of opnieuw proberen`,
  bulkSending: 'Verzenden...',
  bulkSendingDoneWithFailures: (n) => `${n} mislukt om te sturen`,
  bulkSendingReachingOut: (name) => `${name} benaderen...`,
  bulkSendingFailure: (name) => `Verzenden naar ${name} mislukt`,
  bulkIndeedWaitingForReply: 'Wachten op Indeed-reactie',
  bulkIndeedSendingFailure: (name) => `Indeed-bericht verzenden naar ${name} mislukt`,
  bulkIndeedCheckSession: 'Controleer je Indeed-sessie',
  dontShowMessagePreviewNextTime: 'Toon geen voorbeeld van e-mailberichten',
  dontShowWhatsappMessagePreviewNextTime: 'Toon de volgende keer geen WhatsApp-berichtvoorbeeld.',
  changingTheJobWillRestart: 'Wanneer je de vacature wijzigt, wordt het communicatieproces opnieuw gestart',

  working_hours_per_week: 'Werkuren per week',
  available_days: 'Beschikbare dagen',
  readyForJobOffersLabel: 'Klaar voor aanbod',
  travel_time: 'Reistijd',
  transportation: 'Vervoer',
  reachedOutQuestion: 'Heb je contact opgenomen?',
  reachedOutQuestionDescription:
    'Laat het ons weten, dan passen wij de status aan en weet jij precies wie je al gesproken hebt.',
  noNotYet: 'Nee, nog niet',
  yesMarkAsContacted: 'Ja, markeer als gecontacteerd',
  detachJob: 'Vacature loskoppelen',

  candidateIsMovedTo: (candidateName, status) => `${candidateName} is verplaatst naar ${status}`,
  weUnderstandThanks: 'We begrijpen het, bedankt!',
  noMoreJobAlertsFromUs: 'Je ontvangt geen baanaanbiedingen meer van ons. Bedankt voor je feedback.',
  recruiterWillReachOutSoonConfirmation: 'Een recruiter neemt snel contact met je op.',
  viewVacancy: 'Bekijk vacature',
  noVacancyAnymore: 'Geen vacature meer',
  toChangeYourEmailPleaseEnterYourPassword: 'Om je e-mail te wijzigen, voer je wachtwoord in',
  rjCommHubWhatsAppMessage: ({
    candidateFirstName,
    recruiterFirstName,
    companyName,
    jobBoardName,
    vacancyName,
    vacancyLocation,
    vacancySalary,
    vacancyShift,
    includeEmailNote,
  }) => {
    const jobDetails = [vacancyName, vacancyLocation, vacancySalary, vacancyShift].filter(Boolean);

    return (
      <span>
        Hoi {candidateFirstName},
        <br />
        <br />
        {recruiterFirstName} van {companyName} zag je CV op {jobBoardName} en wil graag met je praten over deze
        vacature:
        <br />
        <br />
        {jobDetails.map((line) => (
          <>
            {line}
            <br />
          </>
        ))}
        {includeEmailNote ? (
          <>
            <br />
            Je hebt deze baan ook per mail ontvangen.
          </>
        ) : (
          <>
            <br />
            Wil je meer weten? Klik hieronder om deze baan te bekijken.
          </>
        )}
      </span>
    );
  },
  rjCommHubWhatsAppMessageString: ({
    candidateFirstName,
    recruiterFirstName,
    companyName,
    jobBoardName,
    vacancyName,
    vacancyLocation,
    vacancySalary,
    vacancyShift,
    includeEmailNote,
  }) => {
    const jobDetails = [vacancyName, vacancyLocation, vacancySalary, vacancyShift].filter(Boolean).join('\n');
    const message = `Hoi ${candidateFirstName},\n\n${recruiterFirstName} van ${companyName} zag je CV op ${jobBoardName} en wil graag met je praten over deze vacature:\n\n${jobDetails}`;

    return includeEmailNote
      ? `${message}\n\nJe hebt deze baan ook per mail ontvangen.`
      : `${message}\n\nWil je meer weten? Klik hieronder om deze baan te bekijken.`;
  },

  checked: 'Gecheckt',
  checkedCandidateInfoAt: (lastVerifiedAt: string) => (
    <>
      Kandidaatinfo is bevestigd door de kandidaat
      <br />
      {lastVerifiedAt}
    </>
  ),
  checkedPreferencesAt: (lastVerifiedAt: string) => (
    <>
      Werkvoorkeuren zijn bevestigd door de kandidaat
      <br />
      {lastVerifiedAt}
    </>
  ),
  checkedAvailabilityAt: (lastVerifiedAt: string) => (
    <>
      Beschikbaar voor werk
      <br />
      bevestigd {lastVerifiedAt}
    </>
  ),
  hideCandidateFeedbackTitle: 'Help ons je matches te verbeteren',
  hideCandidateFeedbackDescription:
    'Kun je aangeven waarom je deze kandidaat verbergt? Jouw feedback maakt ons matchingsysteem slimmer.',
  hideCandidateFeedbackReasonIrrelevantExperience: 'Niet relevante werkervaring of vaardigheden',
  hideCandidateFeedbackReasonMismatchedPreferences: 'Niet-passende carrièrevoorkeuren',
  hideCandidateFeedbackReasonLocation: 'Ongeschikte locatie of reistijd',
  hideCandidateFeedbackReasonQualifications: "Onvoldoende kwalificaties (diploma's, certificaten, talen)",
  hideCandidateFeedbackReasonLowQuality: 'Verouderd of lage kwaliteit profiel/cv',
  hideCandidateFeedbackDetailsPlaceholder: 'Meer details toevoegen (optioneel)',

  /* ---- start: added by AI ---- */

  // Questionnaire Screen
  weNeedABitMoreInfo: 'We hebben wat meer informatie nodig',
  someDetailsAreMissing: (jobBoard: string) => (
    <>
      Sommige gegevens ontbreken in je <strong>{jobBoard}</strong> profiel. Door ze toe te voegen kunnen recruiters je
      volledige profiel zien en versnelt het aanwervingsproces.
    </>
  ),
  addingThemWillHelp:
    'Door ze toe te voegen kunnen recruiters je volledige profiel zien en versnelt het aanwervingsproces.',
  areYouCurrentlyOpenToWork: 'Ben je momenteel beschikbaar voor werk?',
  doYouHaveFollowingCertificates: 'Heb je de volgende certificaten en/of rijbewijzen?',
  doYouHaveAnyOtherCertificates: 'Welke certificaten en/of rijbewijzen heb je nog meer?',
  whatIsYourDesiredSalaryRange: 'Wat is je gewenste salaris?',
  isThisIncomeAcceptableForYou: 'Is dit inkomen acceptabel voor jou?',
  thisJobOffersASalary: (amount: string, unit: string) =>
    `Deze baan biedt een salaris van €${amount}${unit ? ` per ${unit}` : ''}`,
  areYouAvailableForThisSchedule: 'Ben je beschikbaar voor dit schema?',
  doYouHaveAnyOtherShiftAvailable: 'Heb je andere shifts beschikbaar?',
  whatAreYouAvailableDays: 'Welke dagen ben je beschikbaar?',
  areYouComfortableWithTheseRequirements: 'Voel je je comfortabel met deze vereisten?',
  areYouAbleToPerformTheseSpecificJobTasks: 'Kan je deze taken uitvoeren?',
  pleaseTellUsAboutAnyLimitationsOrPreferences: 'Vertel ons over eventuele beperkingen of voorkeuren',
  areThereAnyOtherTasksYouCanDo: 'Zijn er nog andere taken die je kunt uitvoeren?',
  requiresWorkingHours: (hours: string, unit: string) => `Vereist werken ${hours} uur per ${unit}`,
  howManyHoursPerWeekWouldYouLikeToWork: (unit: string) => `Kun je dit aantal uren per ${unit} werken`,
  doTheseHoursPerWeekWorkForYou: 'Kun je dit aantal uren per week werken?',
  doYouSpeakTheseLanguages: 'Spreek je deze talen?',
  whichLanguagesDoYouSpeak: 'Welke talen spreek je?',
  submitAndUpdateInfo: 'Indienen en informatie bijwerken',
  byConfirming:
    'Door te bevestigen ga je akkoord met het delen van je profiel met geverifieerde recruiters om gematcht te worden met relevante kansen.',
  typeAndPressEnterToAdd: 'Typ en druk op Enter om toe te voegen...',
  to: 'tot',
  couldNotGenerateEnrichedVacancy: 'We konden de verrijking van de vacature niet genereren',
  couldNotGenerateJobPreview: 'We konden de job preview niet genereren',
  previewInIndeed: 'Voorbeeld in Indeed',
  previewInIndeedModalTitle: 'Dit is hoe je vacature eruit zal zien in Indeed',
  previewInIndeedModalDescription:
    'Sommige opmaak (zoals vetgedrukte tekst, lijsten of kleuren) wordt niet ondersteund op Indeed en wordt verwijderd. Wat je hier ziet is de platte-tekst versie die kandidaten zullen zien',
  backToJobPreview: 'Terug naar vacature preview',
  backToEditor: 'Terug naar editor',
  addMore: 'Meer toevoegen',
  daily: 'dagelijks',
  week: 'week',
  day: 'dag',
  hour: 'uur',
  workShiftAvailability: 'Beschikbaarheid werkdiensten',
  certificationsLicenses: 'Certificaten / licenties',
  languagesSpoken: 'Gesproken talen',
  yourProfileHasBeenUpdated: 'Je profiel is bijgewerkt!',
  yourInformationIsNowComplete:
    'Je informatie is nu compleet en gedeeld met de recruiter. Dit helpt het aanwervingsproces te versnellen.',
  questionnaireCompleteTitle: 'Je bent klaar',
  questionnaireCompleteMessage:
    'Je hebt alle vragen beantwoord. Je profiel is compleet en klaar om bekeken te worden. De recruiter neemt snel contact met je op.',
  jobAlertsActivated: 'Vacature-alerts geactiveerd!',
  wellKeepYouUpdatedWithMoreJobOpportunities:
    'We houden je op de hoogte van meer vacatures die passen bij je interesses. Bedankt dat je verbonden blijft!',
  jobNotificationsEnabledTitle: 'Je bent helemaal klaar!',
  jobNotificationsEnabledDescription:
    'Robin laat je weten zodra er een nieuwe vacature bij je profiel past. Geen spam in je inbox, dat beloven we.',
  youllHearFromUs: 'Je hoort van ons',
  wellReachOutWhenAJobMatchesYourProfile: 'We nemen contact met je op zodra er een vacature bij je profiel past.',
  confirmUnsubscribeTitle: 'Bevestig uitschrijven',
  confirmUnsubscribeDescription:
    'Je ontvangt geen vacature-alerts meer van ons. Je kunt je later altijd opnieuw inschrijven.',
  confirmUnsubscribe: 'Bevestig uitschrijven',
  confirmUnsubscribeFooterText:
    'Door te bevestigen, kies je ervoor om je profiel niet te delen met geverifieerde recruiters, en je wordt niet gekoppeld aan relevante vacatures.',
  updateYourProfile: 'Update je profiel',
  keepYourInformationUpToDate: 'Houd je informatie up-to-date op Robin om betere vacature-matches te krijgen.',
  saveProfile: 'Profiel opslaan',
  interviewWithRecruiterFromCompany: (recruiterFirstName: string, companyName: string) =>
    `Interview met ${recruiterFirstName} van ${companyName}`,

  messagesPulledSuccessfully: 'Berichten succesvol opgehaald!',
  messagesPulledFailed: 'Oeps! Berichten niet opgehaald.',
  messagesSynced: 'Berichten gesynchroniseerd',
  messagesNotSynced: 'Niet gesynchroniseerd',
  lastJobboardMessage: (jobboard: string) => `Laatste ${jobboard}-bericht`,
  clickResyncToTryAgainOrReachOutToSupport: 'Klik op "Resync". Bij aanhoudende problemen, bel support.',
  lastSynced: 'Laatst gesynchroniseerd op',
  resync: 'Resync',
  noMessagesFound: 'Geen berichten gevonden',
  statusesDropdownLabel: 'Automatisch status toewijzen (kandidaten die reageren krijgen deze status in je ATS).',
  refreshStatuses: 'Statuses vernieuwen',
  youAreNotAllowedToRefreshStatusesToday: 'Je mag statuses één keer per dag vernieuwen.',
  whoAreYouHiringToday: 'Wie ben je vandaag aan het werven?',
  jobPreviewIsAvailable: 'Vacaturevoorbeeld is nu beschikbaar!',

  viewFullJobDetails: 'Bekijk volledige vacaturedetails',
  noCandidatesFound: 'Geen kandidaten gevonden',
  keyResponsabilities: 'Key responsabilities',
  salaryRange: 'Salarisbereik',
  languageLevel: 'Taalniveau',
  chooseAFileOrDragAndDrop: 'Kies een bestand of sleep en neer',
  uploadFileToGetStarted: 'Upload een PDF of Word document om te beginnen',
  creatingChatFrom: (source: string) => `Chat aanmaken van ${source}...`,
  matchRate: 'Match percentage',
  whoIsRobinJr: 'Wie is Robin Jr?',
  howCanIConnectMyAts: 'Hoe kan ik mijn ATS koppelen?',
  canIUploadAFile: 'Kan ik een bestand uploaden?',
  messageSentTo: (name: string) => `Bericht verstuurd aan ${name}`,
  searchOrCreateLabel: 'Zoek of maak label',
  selectCallOutcome: 'Selecteer uitkomst',
  copiedToClipboard: 'Gekopieerd naar klembord',
  emailNotAvaialbe: 'E-mail niet beschikbaar',
  enterCandidateEmail: 'Voer de e-mail van de kandidaat in',
  scheduleInterviewNow: 'Plan nu een interview',
  pleaseGrantAccessToYourCalendar: 'Geef toegang tot je agenda om de interviewplanner te gebruiken',
  pleaseConnectYourEmailToUseInterviewScheduler: 'Koppel je e-mail om de interviewplanner te gebruiken',
  schedulerInviteSubject: 'Interviewuitnodiging – Plan je afspraak',
  schedulerInviteMessage: `<span>Hallo {firstName},</span><br/><br/><span>We willen een interview met je opzetten. Klik op de link hieronder en kies een tijd die bij jou past:</span><br/><br/><span>{schedulerLink}</span><br/><br/><span>Als je geen goede tijd kunt vinden of hulp nodig hebt, reageer gewoon op deze e-mail.</span><br/><br/><span>Met vriendelijke groet,</span><br/><br/><span>{recruiterFullName}</span>`,
  schedulerLinkText: 'Plan interview',
  theFollowingFieldsAreRequired: 'De volgende velden zijn verplicht:',
  currentStatus: 'Huidige status:',
  whatTypeOfInterviewWouldYouLikeToSchedule: 'Wat type interview wil je plannen?',
  setupInterview: 'Interview instellen',
  dontShowSetupInterviewAgain: "Laat 'Interview instellen' niet opnieuw zien",
  youCanManageEmailSettings: (
    <span>
      Je kunt deze interview-event opties in je{' '}
      <a href="/email-settings" target="_blank" rel="noopener noreferrer" className="default-link">
        e-mailinstellingen
      </a>{' '}
      beheren
    </span>
  ),
  typeToSearchForAnAddress: 'Typ om een adres te zoeken',
  matchInsights: 'Match-inzichten',
  checkedPreferences: 'Bevestigde voorkeuren',
  seeMatchedCandidates: 'Bekijk gematcheerde kandidaten',
  searchButtonIsReady:
    'Je vacaturevoorbeeld en zoekfunctie zijn klaar. Controleer en verbeter de beschrijving voordat je opslaat, omdat kandidaten hun beslissing baseren op deze beschrijving.',
  /* ---- end: added by AI ---- */

  discardChangesModalTitle: 'Wijzigingen verwerpen?',
  discardChangesModalDescription: 'Je hebt ongesavede wijzigingen. Weet je zeker dat je ze wilt verwerpen?',
  keepEditing: 'Blijf bewerken',
  discardChanges: 'Wijzigingen verwerpen',
  jobTitleAndStatus: (jobTitle: string, status: string) => `${jobTitle} ${status ? `en ${status}` : ''}`,
  writeWithAi: 'Schrijf met AI',
  writingCustomizedMessage: 'We schrijven een bericht op maat, op basis van het CV en jouw vacature.',
  nylasCalendarConnectionModalTitle: 'Laat geschikte kandidaten meteen plannen',
  nylasCalendarConnectionModalDescription: (
    <>
      Stel je kalender in, zodat kandidaten na kwalificatie direct een gesprek kunnen boeken.
      <br />
      Zo laat je geen match liggen.
    </>
  ),
  nylasCalendarConnectionModalConnectCalendar: 'Koppel je kalender in de e-mailinstellingen om te beginnen',
  nylasCalendarConnectionModalCalendarSetUpTitle: 'Je kalender is ingesteld',
  nylasCalendarConnectionModalCalendarSetUpText: 'Kandidaten kunnen nu zelf een gesprek in plannen.',
  nylasCalendarStatusValid: 'Verbonden',
  nylasCalendarStatusInvalid: 'Ongeldig',
  nylasCalendarStatusNotConnected: 'Niet verbonden',
  nylasCalendarStatusError: 'Fout',
  nylasCalendarStatusUnknown: 'Onbekend',
  goToEmailSettings: 'Ga naar e-mailinstellingen',
  maybeLater: 'Misschien later',
  videoInterviewAboutTheVacancy: 'Videogesprek over de vacature',
  introductionAtTheLocation: 'Kennismaking op de vestiging',
  telephoneConversationAboutTheVacancy: 'Telefoongesprek over de vacature',
  onlineInterview: 'Online interview',
  inPersonInterview: 'Interview op locatie',
  callInterview: 'Telefooninterview',
  role: 'Functie',
  weFoundSomeGreatMatchesForYou: 'We hebben geweldige matches voor je gevonden!',
  failedToLoadJobRecommendations: 'Vacatureaanbevelingen konden niet worden geladen.',
  interviewFeedbackTitle: 'Vertel ons wat meer',
  interviewFeedbackSubtitleFallback: 'Over je recente gesprek.',
  interviewFeedbackSubtitleCandidateFull: (name, jobTitle) =>
    `Over je gesprek met ${name} voor de functie ${jobTitle}.`,
  interviewFeedbackSubtitleCandidateName: (name) => `Over je gesprek met ${name}.`,
  interviewFeedbackSubtitleRecruiterFull: (name, jobTitle) =>
    `Over je gesprek met ${name} voor de functie ${jobTitle}.`,
  interviewFeedbackSubtitleRecruiterName: (name) => `Over je gesprek met ${name}.`,
  interviewFeedbackTagsLabelHigh: 'Wat viel positief op?',
  interviewFeedbackTagsLabelLow: 'Wat had beter gekund?',
  interviewFeedbackCommentLabelHigh: 'Nog iets? (optioneel)',
  interviewFeedbackCommentLabelLow: 'Vertel ons meer (optioneel)',
  interviewFeedbackCommentPlaceholder: 'Schrijf hier je feedback',
  interviewFeedbackSubmit: 'Feedback versturen',
  interviewFeedbackThankYouTitle: 'Bedankt voor je feedback',
  interviewFeedbackThankYouHigh: 'Fijn dat het goed ging. We blijven werken aan een nog betere volgende match.',
  interviewFeedbackThankYouLowTitle: 'Bedankt voor je eerlijkheid',
  interviewFeedbackThankYouLow:
    'Jammer dat het niet beter was. Het team gaat ermee aan de slag voor een volgende keer.',
  interviewFeedbackReviewTitle: 'Bedankt voor je feedback',
  interviewFeedbackReviewBody:
    'Fijn dat het goed ging. Zou je dat op Google willen delen? Het helpt anderen ons te vinden.',
  interviewFeedbackReviewButton: 'Laat een Google-review achter',
  interviewFeedbackInvalidTitle: 'Deze link is niet geldig',
  interviewFeedbackInvalidBody:
    'Mogelijk is hij verlopen of al gebruikt. Wil je toch feedback geven? Reageer dan op het bericht van Robin.',
  interviewFeedbackTagCommunication: 'Communicatie',
  interviewFeedbackTagScheduling: 'Planning',
  interviewFeedbackTagClarity: 'Duidelijkheid van informatie',
  interviewFeedbackTagSpeed: 'Snelheid',
  interviewFeedbackTagInterviewer: 'De interviewer',
  interviewFeedbackTagOverall: 'Algeheel proces',
  screeningSubmit: 'Versturen',
  screeningSubmitting: 'Bezig met versturen…',
  screeningLoading: 'Bezig met laden…',
  screeningRetry: 'Opnieuw proberen',
  screeningSubmitError: 'We konden je antwoorden niet versturen. Probeer het opnieuw.',
  screeningPassedTitle: 'Bedankt!',
  screeningPassedBody: 'Je antwoorden zijn ontvangen. We nemen snel contact met je op.',
  screeningNeutralTitle: 'We verwerken je sollicitatie',
  screeningNeutralBody: 'We nemen contact met je op.',
  screeningInvalidTitle: 'Deze link is niet geldig.',
  screeningInvalidBody: 'Controleer of je de volledige link uit je bericht hebt geopend.',
  screeningErrorTitle: 'Er is iets misgegaan',
  screeningErrorBody: 'We konden de vragen niet laden. Probeer het opnieuw.',
  screeningMethodTitle: 'Hoe wil je het gesprek voeren?',
  screeningMethodHumanLabel: 'Met een recruiter',
  screeningMethodHumanBody: 'Kies een moment dat jou uitkomt en voer een online gesprek met iemand van het team.',
  screeningMethodAiLabel: 'Met onze AI-recruiter',
  screeningMethodAiBody:
    'Voer een kort video-interview op een moment dat jou uitkomt. Je beantwoordt enkele vragen over je ervaring, vaardigheden en motivatie via je smartphone, tablet of laptop.',
  screeningMethodFinalNote: 'Je kunt dit later wijzigen.',
  screeningMethodConfirm: 'Bevestig mijn keuze',
  screeningMethodError: 'We konden je keuze niet opslaan. Probeer het opnieuw.',
  screeningBookedTitle: 'Je gesprek staat ingepland',
  screeningBookedBody: 'Neem contact op met je recruiter als je de details wilt nakijken of wijzigen.',
  screeningOnboardingBookedTitle: 'Je onboardingsessie staat ingepland',
  screeningOnboardingBookedBody: 'We hebben de gegevens naar je e-mailadres gestuurd.',
  applyOnboardingAppointmentLabel: 'Onboardingsessie',
  applyOnboardingScheduleTitle: 'Kies je onboardingsessie',
  applyOnboardingScheduleBody: 'Je komt bij ons langs. Kies het moment dat jou het beste past.',
  applyOnboardingFullTitle: 'Alle sessies zijn nu vol',
  applyOnboardingFullBody:
    'Alle onboardingsessies van de komende weken zijn volgeboekt. Kijk over een dag of twee nog eens — er komen regelmatig nieuwe momenten bij.',
  applyOnboardingConfirmTitle: 'Is dit het juiste moment?',
  applyOnboardingConfirmBody: 'Je kunt dit later nog wijzigen, zolang je sessie nog niet is begonnen.',
  applyOnboardingConfirmCta: 'Boek deze sessie',
  applyOnboardingFieldWhere: 'Waar',
  applyOnboardingAddToCalendar: 'Zet in mijn agenda',
  applyOnboardingChangeUntilSoon: 'Je kunt tot kort voor je sessie wijzigen.',
  applyOnboardingSessionFull: 'Iemand was net eerder met de laatste plek. Kies een ander moment.',
  applyOnboardingSessionClosed: 'Dit moment is niet meer beschikbaar. Kies een ander moment.',
  applyOnboardingNotReschedulable: 'Je sessie begint te snel om te verzetten. Je plek blijft staan.',
  applyOnboardingBookError: 'We konden deze sessie niet boeken. Probeer het opnieuw.',
  screeningBookingOrganizer: 'Met',
  screeningAiPendingTitle: 'Je bent klaar',
  screeningAiPreparingBody: 'We zetten je gesprek nu klaar. Dit duurt maar even.',
  screeningAiPendingBody: 'We mailen je de link zodra die klaar is.',
  screeningDisqualifiedTitle: 'We kunnen je sollicitatie niet voortzetten',
  screeningDisqualifiedBody: 'Op basis van onderstaande antwoorden past deze functie op dit moment niet.',
  screeningDisqualifiedAnswerLabel: 'Jouw antwoord:',
  applyInterviewTitle: 'Mijn gesprek',
  applyInterviewRightNow: 'Nu',
  applyInterviewOptionsLabel: 'Je opties',
  applyInterviewOptionHumanTitle: 'Toch een recruiter spreken',
  applyInterviewOptionHumanBody: 'Kies een moment dat jou uitkomt.',
  applyInterviewOptionAiTitle: 'Overstappen naar onze AI-recruiter',
  applyInterviewOptionAiBody: 'Een kort video-interview, op een moment dat jou uitkomt.',
  applyInterviewOptionRescheduleTitle: 'Tijd wijzigen',
  applyInterviewOptionRescheduleBody: 'Kies een moment dat jou uitkomt.',
  applyInterviewFieldHow: 'Hoe',
  applyInterviewHowVideo: 'Videogesprek',
  // The prototype's own `chanPhone`, which the channel picker and every How row share.
  applyInterviewHowPhone: 'Telefoongesprek',
  applyInterviewFieldWhere: 'Waar',
  applyInterviewWhereVideo: 'Een link in je mail',
  applyChannelPhoneLead: 'Een recruiter belt je op',
  applyChannelPhoneChange: 'Wijzigen',
  applyChannelPhoneSave: 'Opslaan',
  applyChannelPhoneInvalid: 'We kunnen dit nummer niet bellen. Controleer het en probeer het opnieuw.',
  applyInterviewBack: 'Terug',
  applyInterviewUnbookedTitle: 'Je moet nog een moment kiezen',
  // Disabled 2026-10-20: interview method choice. Was:
  // 'Je hebt gekozen om een recruiter te spreken, maar er staat nog geen moment vast. Kies er een om je sollicitatie af te ronden.'
  applyInterviewUnbookedBody:
    'Er staat nog geen moment vast voor je gesprek met een recruiter. Kies er een om je sollicitatie af te ronden.',
  applyInterviewUnbookedWhen: 'Nog niet gekozen',
  applyInterviewUnbookedWith: 'Een recruiter',
  applyInterviewContinueCta: 'Verder met mijn sollicitatie',
  applyInterviewChangeUntilSubmit: 'Je kunt wijzigen totdat je het interview inlevert.',
  applyInterviewChangeUntil: (when: string) => `Je kunt tot ${when} wijzigen.`,
  applyInterviewChangeUntilSoon: 'Je kunt tot kort voor je gesprek wijzigen.',
  applyInterviewClosedCallTitle: 'Te laat om dit te wijzigen',
  applyInterviewClosedCallBody: 'Je gesprek is over minder dan 4 uur en blijft zoals het is.',
  applyInterviewClosedAiTitle: 'Je antwoorden liggen bij een recruiter',
  applyInterviewClosedAiBody:
    'Je hebt het interview afgerond, dus hier valt niets meer te wijzigen. Een recruiter leest elk antwoord en neemt contact met je op.',
  applyInterviewBookTitle: 'Plan je gesprek met onze recruiter',
  applyInterviewBookBody: 'Kies een moment dat jou uitkomt.',
  applyInterviewDoneBookedTitle: 'Je gesprek staat gepland',
  applyInterviewDoneMovedTitle: 'Je gesprek is verzet',
  applyInterviewDoneAiTitle: 'Je AI-interview staat klaar',
  applyInterviewDoneSub: (email: string) => `We hebben de bevestiging verzonden naar ${email}.`,
  applyInterviewDoneSubFallback: 'We hebben de bevestiging naar je e-mail verzonden.',
  // De checklist hoort bij de subtitel, niet bij een eigen blok: de kaart rendert één body-string,
  // en de regelafbrekingen blijven staan dank zij `white-space: pre-line` op `ApplyStateCard`.
  applyInterviewDoneAiSub:
    'Je kunt nu starten of later verdergaan via de link in de mail. Rond het interview wel af binnen 24 uur nadat je onze eerste mail met de link hebt ontvangen.\n\nDit heb je nodig:\n• 10 tot 15 minuten\n• Een rustige plek\n• Een smartphone, tablet of laptop met camera\n• Stabiele internetverbinding',
  applyInterviewChangeCta: 'Mijn gesprek wijzigen',
  applyInterviewAskAiTitle: 'Overstappen naar onze AI-recruiter?',
  applyInterviewAskAiBody:
    'Je gesprek met een recruiter wordt geannuleerd en de tijd gaat terug naar het team. Je voert zelf een kort video-interview, wanneer je wilt binnen 24 uur.',
  applyInterviewAskAiUnbookedBody: 'Je voert zelf een kort video-interview, wanneer je wilt binnen 24 uur.',
  applyInterviewAskAiConfirm: 'Ja, wijzigen',
  applyInterviewSwitchNotice:
    'Zodra je dit moment bevestigt, telt je AI-interview niet meer mee. Vanaf dan telt alleen het gesprek met de recruiter.',
  changeInterviewError: 'We konden je keuze niet wijzigen. Probeer het opnieuw.',
  changeInterviewAiUnavailable: 'Onze AI-recruiter is niet beschikbaar voor deze functie. Er is niets veranderd.',
  changeInterviewAiFailed:
    'We konden je gesprek nu niet klaarzetten. Er is niets veranderd, je kunt het opnieuw proberen.',
  changeInterviewAiFailedBooked:
    'We konden je gesprek nu niet klaarzetten. Je afspraak met de recruiter staat nog gewoon in je agenda. Je kunt het opnieuw proberen.',
  applyContinue: 'Verder',
  applyStepQuestions: 'Vragen',
  applyStepMethod: 'Soort gesprek',
  applyStepSchedule: 'Plannen',
  applyStepConfirm: 'Bevestigen',
  applyStepCounter: (step: number, total: number) => `Stap ${step} van ${total}`,
  applyQuestionCounter: (question: number, total: number) => `Vraag ${question} van ${total}`,
  applyReviewStepLabel: 'Controleren',
  applyIntroGreeting: (name: string) => `Hoi ${name}`,
  applyIntroGreetingGeneric: 'Hoi',
  applyIntroBody: 'Zet hier de volgende stap in je sollicitatieproces.',
  applyIntroAppliedFor: 'Je solliciteerde op:',
  applyIntroExpectQuestionsTitle: (count: number) => `Beantwoord ${count} korte vragen`,
  applyIntroExpectQuestionsBody: 'Meestal ja of nee.',
  applyIntroExpectMethodTitle: 'Kies het soort gesprek',
  applyIntroExpectMethodBody: 'Met een recruiter, of een AI-interviewer',
  applyIntroExpectScheduleTitle: 'Je gesprek inplannen',
  applyIntroExpectScheduleBody: 'Kies een moment dat jou uitkomt.',
  applyIntroStart: 'Starten',
  applyIntroCheckNote:
    'We checken eerst automatisch of je voldoet aan de belangrijkste eisen voor deze functie. Daarna kijkt een recruiter persoonlijk naar de rest van je sollicitatie.',
  applyReviewTitle: 'Geregistreerde antwoorden',
  applyReviewBody: 'Neem nog even de tijd om je antwoorden te controleren en aan te passen voordat je doorgaat.',
  applyReviewEdit: 'Wijzig',
  applyExitTitle: 'We nemen je sollicitatie niet verder in behandeling',
  applyExitBody:
    'We hebben je antwoorden gecontroleerd op de eisen voor deze functie. Helaas kun je op dit moment niet aan de slag voor deze functie.',
  applyExitReasonsLabel: 'Reden voor afwijzing',
  applyExitClose: 'Jammer dat we je geen beter nieuws kunnen brengen.',
  applyScheduleTitle: 'Plan je gesprek met onze recruiter',
  applyScheduleBody: 'Kies een moment dat je uitkomt.',
  applySchedulePickTime: 'Kies een tijdstip',
  applyScheduleNoTimesTitle: 'Op dit moment geen tijden beschikbaar',
  applyScheduleNoTimesBody: (email: string) =>
    `Er zijn op dit moment geen vrije tijden om uit te kiezen. Mail ons op ${email}, dan helpen we je verder.`,
  applyConfirmTitle: 'Bevestig je gesprek',
  applyConfirmBody: 'Controleer de gegevens en bevestig je afspraak',
  applyConfirmBooking: 'Afspraak bevestigen',
  applyPickAnotherTime: 'Wijzigen',
  applySlotsLoading: 'Beschikbare tijden laden…',
  applySlotsCheckingCalendars: 'We bekijken de agenda’s van de recruiters…',
  applySlotsTakingLong: 'Dit duurt langer dan normaal. We blijven het proberen.',
  applyBookingSubmitting: 'Je gesprek wordt ingepland…',
  applyRescheduleSubmitting: 'Je gesprek wordt verplaatst…',
  applyChannelChangeSubmitting: 'Je gesprek wordt aangepast…',
  applySubmitStillConfirming: 'Nog bezig met bevestigen…',
  applySubmitDontClose: 'Sluit deze pagina alsjeblieft niet.',
  applyFieldRole: 'Functie',
  applyFieldAppointment: 'Afspraak',
  applyFieldTimezone: 'Tijdzone',
  applyFieldRecruiter: 'Recruiter',
  applyFieldRecruiterEmail: 'E-mail recruiter',
  applyBookedTitle: 'Je gesprek is ingepland',
  applyBookedSentTo: (email: string) => `We hebben de bevestiging verzonden naar ${email}`,
  applyBookedSentToGeneric: 'We hebben de gegevens naar je e-mail gestuurd.',
  applyBookedChangeTime: 'Mijn tijd wijzigen',
  applyAiInterviewReadyTitle: 'Je gesprek staat klaar',
  applyAiInterviewReadyBody: 'Je kunt nu beginnen, of later terugkomen via deze link.',
  applyAiInterviewWhen: 'Wanneer je wilt, binnen 24 uur',
  applyAiInterviewPartner: 'Braintrust AI-interviewpartner',
  applyAiInterviewStart: 'Start gesprek',
  applyAiLegalLead:
    'Belangrijk: Een recruiter beoordeelt de resultaten altijd persoonlijk. Het AI-interview is nooit automatisch doorslaggevend.',
  applyAiLegalBody:
    'Je gegevens gebruiken we uitsluitend voor de beoordeling van je sollicitatie. We verwerken deze volgens de Algemene Verordening Gegevensbescherming (AVG) en bewaren ze niet langer dan nodig. Meer informatie: Privacyverklaring Adecco',
  /// TODO: hardcoded tenant mailbox — swap for the tenant's support email when one is available.
  applyAiLegalAccessibility:
    'Dit gesprek gebruikt AI. Dat betekent dat technologie helpt bij het bekijken van je antwoorden. We willen dat iedereen het gesprek goed kan doen. Lukt iets niet? Bijvoorbeeld door een beperking, een technisch probleem of omdat de AI niet goed werkt? Mail ons dan zo snel mogelijk via ubereats@adecco.nl. We kijken dan samen naar een oplossing.',

  // De landingspagina na het gesprek. B1, informeel "je", geen uitroeptekens — geen termijn
  // en geen uitkomst beloven.
  intakeCompleteTitle: 'Gesprek afgerond',
  intakeCompleteBody:
    'Dank je wel voor het gesprek. Onze recruiter gaat aan de slag met je antwoorden en neemt daarna contact met je op.',
  intakeCompleteProfileNote: 'Maak een Adecco-profiel aan of werk je gegevens bij.',
  intakeCompleteCta: 'Naar My-Adecco',
  intakeTrackerApplied: 'Solliciteren',
  intakeTrackerInterview: 'Gesprek',
  intakeTrackerReview: 'Beoordeling',
  intakeTrackerContact: 'Contact',
  intakeTrackerProgress: (step: number, total: number) => `Voortgang sollicitatie: stap ${step} van ${total}`,
  intakeFeedbackQuestion: 'Hoe beoordeel je dit sollicitatieproces?',
  intakeFeedbackStar: (stars: number) => (stars === 1 ? '1 ster' : `${stars} sterren`),
  intakeFeedbackGroupLabel: 'Geef je ervaring een score van 1 tot 5 sterren',
  intakeFeedbackCommentPlaceholder: 'Vertel er meer over (optioneel)',
  intakeFeedbackSend: 'Feedback versturen',
  intakeFeedbackNeedsRating: 'Kies eerst een score',
  intakeFeedbackThanksRating: 'Bedankt. Voeg gerust een opmerking toe.',
  intakeFeedbackThanksComment: 'Bedankt voor je feedback. Dit helpt ons het sollicitatieproces te verbeteren.',
  intakeFeedbackPageTitle: 'Jouw feedback',
  intakeFeedbackPageBody:
    'Bedankt dat je laat weten hoe het ging. Je kunt je score altijd aanpassen of een opmerking toevoegen.',

  interviewSchedulingTitle: 'Plan je gesprek in',
  interviewSchedulingGreeting: (name: string) => `Hoi ${name}, kies een moment dat jou uitkomt.`,
  interviewSchedulingGreetingFallback: 'Kies een moment dat jou uitkomt.',
  interviewSchedulingDuration: (minutes: number) => `${minutes} min`,
  interviewSchedulingPickDate: 'Kies een dag',
  interviewSchedulingPickTime: 'Kies een tijd',
  interviewSchedulingPickDayFirst: 'Selecteer een dag om de beschikbare tijden te zien.',
  interviewSchedulingNoTimesInMonth:
    'Deze maand zijn er geen tijden. Probeer een andere maand, of neem contact op met je recruiter als er niets past.',
  interviewSchedulingCheckNextMonth: 'Bekijk volgende maand',
  interviewSchedulingTimezoneLabel: 'Tijden weergegeven in',
  interviewSchedulingHostedFrom: (timezone: string) => `Gesprek wordt gehouden vanuit ${timezone}`,
  interviewSchedulingBack: 'Terug',
  interviewSchedulingConfirmTitle: 'Bevestig je gesprek',
  interviewSchedulingConfirmSubtitle: 'Controleer de gegevens voordat je bevestigt.',
  interviewSchedulingFieldWhen: 'Wanneer',
  interviewSchedulingFieldDuration: 'Duur',
  interviewSchedulingFieldName: 'Naam',
  interviewSchedulingFieldEmail: 'E-mail',
  interviewSchedulingFieldOrganizer: 'Met',
  interviewSchedulingFieldOrganizerEmail: 'Contact-e-mail',
  interviewSchedulingConfirmButton: 'Afspraak bevestigen',
  interviewSchedulingBookedTitle: 'Je afspraak is ingepland',
  interviewSchedulingBookedSubtitle: (email: string) => `We hebben de gegevens naar ${email} gestuurd.`,
  interviewSchedulingJoinMeeting: 'Deelnemen aan gesprek',
  interviewSchedulingNoConferencing: 'Je ontvangt de gegevens van het gesprek per e-mail.',
  interviewSchedulingSlotTakenTitle: 'Dit tijdstip is net bezet',
  interviewSchedulingSlotTakenBody: 'Iemand heeft het geboekt terwijl je aan het kiezen was. Kies een ander tijdstip.',
  interviewSchedulingProviderDownTitle: 'De agenda reageerde niet',
  interviewSchedulingProviderDownBody: 'Je tijdstip staat nog geselecteerd — probeer opnieuw te bevestigen.',
  interviewSchedulingRetry: 'Probeer opnieuw',
  interviewSchedulingInvalidTitle: 'Deze link is niet geldig',
  interviewSchedulingInvalidBody: 'Mogelijk is hij aangepast of verkeerd gekopieerd. Vraag om een nieuwe link.',
  interviewSchedulingExpiredTitle: 'Deze link is verlopen',
  interviewSchedulingExpiredBody: 'Reageer op het bericht dat je hebt ontvangen en vraag om een nieuwe planningslink.',
  interviewSchedulingUnavailableTitle: 'Inplannen is nu niet mogelijk',
  interviewSchedulingUnavailableBody: 'Er is op dit moment niemand beschikbaar. Probeer het later opnieuw.',
  interviewSchedulingGenericErrorTitle: 'Er is iets misgegaan',
  interviewSchedulingGenericErrorBody: 'We konden de beschikbare tijden niet laden. Probeer het opnieuw.',

  // Booking reschedule
  bookingUsageInterview: 'gesprek',
  bookingUsageOnboarding: 'onboardingsessie',
  bookingUsageDefault: 'afspraak',
  bookingRescheduleTitle: 'Je afspraak wijzigen',
  bookingRescheduleBody: 'Kies een nieuw moment dat je beter uitkomt.',
  bookingRescheduleCurrentTitle: 'Je afspraak nu',
  bookingRescheduleFieldOrganizer: 'Met',
  bookingRescheduleFieldCurrentTime: 'Huidige tijd',
  bookingRescheduleFieldNewTime: 'Nieuwe tijd',
  bookingRescheduleWindowFrom: (from: string) => `Je kunt elk nieuw moment vanaf ${from} kiezen.`,
  bookingRescheduleWindowBetween: (from: string, to: string) =>
    `Je kunt een nieuw moment kiezen tussen ${from} en ${to}.`,
  bookingReschedulePickNewTime: 'Kies een nieuwe tijd',
  bookingRescheduleContinue: 'Doorgaan',
  bookingRescheduleConfirmTitle: 'Bevestig je nieuwe tijd',
  bookingRescheduleConfirmBody: 'Je oude tijd komt vrij zodra je bevestigt.',
  bookingRescheduleChannelOnlyTitle: 'Bevestig hoe je wilt praten',
  bookingRescheduleChannelOnlyBody: 'Je tijd blijft hetzelfde. Alleen de manier waarop je praat verandert.',
  bookingRescheduleDoneChannelTitle: 'Je gesprek is gewijzigd',
  bookingRescheduleNewLinkNotice: 'Je krijgt een nieuwe link. De link die je nu hebt werkt niet meer.',
  bookingRescheduleConfirmButton: 'Nieuwe tijd bevestigen',
  bookingRescheduleOutsideWindowTitle: 'Die tijd is niet meer toegestaan',
  bookingRescheduleOutsideWindowBody: 'Ga terug en kies een tijd binnen het getoonde bereik.',
  bookingOutsideWindowTitle: 'Die tijd is niet meer toegestaan',
  bookingOutsideWindowBody: 'Ga terug en kies een andere tijd.',
  bookingRescheduleDoneTitle: 'Je afspraak is verzet',
  bookingRescheduleDoneBody: (email: string) => `We hebben een nieuwe uitnodiging naar ${email} gestuurd.`,
  bookingRescheduleDoneBodyFallback: 'Er is een nieuwe uitnodiging onderweg.',
  bookingRescheduleOldLinkVoid: 'Je vorige uitnodiging en deelnamelink werken niet meer.',
  bookingRescheduleChangeAgain: 'Mijn tijd nogmaals wijzigen',
  bookingRescheduleClosedTitle: 'Deze afspraak kan niet meer worden gewijzigd',
  bookingRescheduleClosedBody: 'De starttijd is te dichtbij. Neem contact op met je recruiter.',
  bookingRescheduleNotFoundTitle: 'Er staat geen afspraak op deze link',
  bookingRescheduleNotFoundBody: 'Mogelijk is die al geannuleerd. Neem contact op met je recruiter.',
  viewFullJob: 'Bekijk volledige vacature',
  applyNow: 'Nu solliciteren',
  notifyMeAboutNewJobs: 'Meld me aan voor nieuwe vacatures',
  imNotLookingRightNow: 'Ik zoek momenteel niet',
  youreSetUpForNewMatchAlerts: 'Je ontvangt nieuwe vacaturemeldingen. We sturen er binnenkort nog een.',
  stopAlerts: 'Meldingen stoppen',
  percentMatch: (percent) => `${percent}% Match`,
  noJobRecommendationsTitle: 'Geen matches op dit moment',
  noJobRecommendationsMessage: 'We laten je weten zodra we een goede match voor jouw profiel hebben gevonden.',
  hereAreJobsThatFitYourProfile: (count) =>
    `Hier ${count === 1 ? 'is' : 'zijn'} ${count} ${count === 1 ? 'vacature' : 'vacatures'} die bij jouw profiel ${count === 1 ? 'past' : 'passen'}`,
  robinUsesYourActivityOnThisPageForBetterMatches:
    'Robin gebruikt je activiteit op deze pagina om betere matches voor je te vinden.',
  rejectCandidateModalTitle: 'Waarom is deze kandidaat niet de juiste match?',
  rejectCandidateModalDescription:
    'Vertel ons wat er niet klopte. Robin gebruikt dit om volgende keer betere matches te sturen.',
  rejectCandidateReasonNotEnoughExperience: 'Niet genoeg ervaring',
  rejectCandidateReasonMissingCertificate: 'Ontbrekend vereist certificaat',
  rejectCandidateReasonNotAvailableForHours: 'Niet beschikbaar voor vereiste uren',
  rejectCandidateReasonLivesTooFar: 'Woont te ver van de werklocatie',
  rejectCandidateReasonPositionFilled: 'Positie al ingevuld',
  rejectCandidateReasonOther: 'Anders',
  rejectCandidateCustomReasonPlaceholder: 'Help de kandidaat om te verbeteren voor een toekomstige baan ...',
  rejectCandidateSubmit: 'Stuur je feedback',
  rejectCandidate: 'Kandidaat afwijzen',
  sendInterviewInvite: 'Stuur uitnodiging voor interview',
  rejected: 'Afgewezen',
  candidateRejectedSuccessfully: 'Kandidaat succesvol verborgen',
  candidateAppliedRecommendation: 'Toegepast',
  whyYouAreTheRightFit: 'Waarom jij de juiste match bent voor deze baan',
  interestedInThisOpportunity: 'Geïnteresseerd in deze vacature? We brengen je direct in contact met de recruiter.',
  backToJobList: 'Terug naar vacaturelijst',
  pauseJobRecommendationsTitle: 'Helemaal begrepen',
  pauseJobRecommendationsDescription:
    'We pauzeren alles aan onze kant. Je gegevens worden verwijderd uit de reach-outlijst van Robin. Je hoort niets meer van ons totdat je zelf terugkomt.',
  pauseJobRecommendationsConfirm: 'Klinkt goed',
  pauseJobRecommendationsKeepShowing: 'Toch maar vacatures blijven zien',
  outreachMonitor: {
    navLabel: 'Indeed-outreach',
    pageTitle: 'Indeed-outreachmonitor',
    pageDescription:
      'Welke recruiters Indeed gekoppeld hebben in de extensie, welke zoekopdrachten Indeed automatiseren, of dat werkt, en wie wacht op contact. Browsergegevens zijn wat de extensie het laatst rapporteerde.',
    impersonating:
      'Je bent ingelogd als een recruiter. De monitor leest alle bedrijven en heeft daarom je eigen staff-account nodig. Stop met inloggen als deze recruiter om hem te gebruiken.',
    stopImpersonating: 'Stoppen met inloggen als recruiter',
    tabs: { searches: 'Zoekopdrachten', installs: 'Browsers', queue: 'Wachtrij', intervals: 'Intervallen' },
    refresh: 'Vernieuwen',
    retry: 'Opnieuw proberen',
    loadFailed: (status) => (status ? `Kon dit niet laden (HTTP ${status}).` : 'Kon dit niet laden.'),
    lookupFailed: 'Kon de lijst niet laden.',
    pageRange: (from, to, count) => `${from}–${to} van ${count}`,
    previousPage: 'Vorige',
    nextPage: 'Volgende',
    never: 'Nooit',
    filters: {
      company: 'Bedrijf',
      companyPlaceholder: 'Elk bedrijf',
      recruiter: 'Recruiter',
      recruiterPlaceholder: 'Elke recruiter',
      recruiterNeedsCompany: 'Kies eerst een bedrijf',
      health: 'Status',
      healthAll: 'Alle zoekopdrachten',
      healthAny: 'Met een probleem',
      search: 'Zoeken',
      searchPlaceholder: 'Zoek op zoekopdracht, bedrijf, recruiter of e-mail',
      advertiserKey: 'Advertiser key',
      advertiserKeyPlaceholder: 'Indeed advertiser key',
      clear: 'Filters wissen',
    },
    healthy: 'In orde',
    healthLabels: {
      no_report: 'Geen rapport',
      indeed_session_invalid: 'Indeed-sessie ongeldig',
      no_credits: 'Geen credits',
      no_project: 'Geen project',
      indeed_queue_stuck: 'Indeed-wachtrij staat stil',
      claim_stuck: 'Claim staat stil',
      failed_recently: 'Recent mislukt',
      limit_reached: 'Limiet bereikt',
    },
    healthDescriptions: {
      no_report:
        'Een browser heeft Indeed aan voor deze zoekopdracht, maar rapporteerde al meer dan 2 uur niet. Een browser die 7 dagen stil is, telt niet meer mee.',
      indeed_session_invalid: 'Een browser met Indeed aan is zijn Indeed-sessie kwijt, of de outreach staat stil.',
      no_credits: 'Een browser met Indeed aan heeft geen Indeed-contactcredits meer.',
      no_project: 'Een browser met Indeed aan heeft geen Indeed-project gekozen, of het project bestaat niet meer.',
      indeed_queue_stuck:
        'Er wachten Indeed-kandidaten en een browser heeft Indeed aan, maar er gebeurde 2 uur lang niets, of een volledige cyclus van de traagste browser als zijn interval langer is.',
      claim_stuck: 'Een browser claimde meer dan een uur geleden kandidaten en is er nog niet mee klaar.',
      failed_recently: 'Minstens één kandidaat is in de laatste 24 uur mislukt.',
      limit_reached: 'Een reach-outlimiet heeft deze zoekopdracht op minstens één kanaal gestopt.',
    },
    outreachGates: {
      no_campaigns: 'Geen campagnes',
      no_header_rule: 'Geen header-regel',
      session_invalid: 'Sessie ongeldig',
      no_credits: 'Geen credits',
      no_sender: 'Geen afzender',
      no_project_list: 'Projectlijst mislukt',
      ready: 'Klaar',
    },
    messagesGates: {
      forced: 'Geforceerd',
      disabled: 'Uitgeschakeld',
      no_header_rule: 'Geen header-regel',
      session_invalid: 'Sessie ongeldig',
      session_valid: 'Sessie geldig',
    },
    queueStatuses: {
      indeed_waiting: 'Indeed, niet geclaimd',
      extension_queued: 'Geclaimd door een browser',
      in_progress: 'Bezig',
      pending: 'In de wachtrij (e-mail/WhatsApp)',
    },
    searches: {
      columns: {
        health: 'Status',
        company: 'Bedrijf',
        search: 'Zoekopdracht',
        owner: 'Eigenaar',
        automation: 'Automatisering',
        indeed: 'Indeed',
        queue: 'Wachtrij',
        used: 'Gebruikt 24u',
        lastRun: 'Laatste run',
      },
      automationOn: 'Aan',
      automationOff: 'Uit',
      threshold: (threshold) => `Vanaf ${threshold}%`,
      untitled: 'Naamloze zoekopdracht',
      ids: (campaignId, chatId) => `Campagne ${campaignId} · chat ${chatId}`,
      indeedBrowsers: (enabled, total) => `${enabled} van ${total} browsers aan`,
      noBrowsers: 'Geen browser',
      queueCell: (waiting, claimed, pending) => `${waiting} wachtend · ${claimed} geclaimd · ${pending} in wachtrij`,
      usedCell: (channel, used, limit) => `${channel} ${used}/${limit}`,
      empty: 'Geen zoekopdrachten voor deze filters.',
    },
    detail: {
      close: 'Sluiten',
      settings: 'Instellingen',
      owner: 'Eigenaar',
      sender: 'Afzender (e-mail/WhatsApp)',
      senderSources: { ats_owner: 'vacature-eigenaar in het ATS', recruiter: 'gekozen door een recruiter' },
      nobody: 'Niemand',
      lastRun: 'Laatste run',
      limits: 'Limieten',
      channelEmailWhatsapp: 'E-mail / WhatsApp',
      channelIndeed: 'Indeed',
      limitSearch: 'Deze zoekopdracht',
      limitInherits: 'Volgt bedrijfsstandaard',
      limitCompanyDefault: 'Bedrijfsstandaard',
      limitMaximum: 'Maximum',
      limitUsed: 'Gebruikt 24u',
      limitBlockedBy: 'Gestopt door',
      blockedBy: (value) => {
        if (value === 'search') return 'Limiet van deze zoekopdracht';
        if (value === 'tenant') return 'Bedrijfslimiet van Robin';

        return value;
      },
      notBlocked: 'Niet gestopt',
      tenantCap: 'Bedrijfslimiet van Robin (alle kanalen)',
      tenantCapNone: 'Geen',
      queue: 'Wachtrij',
      queuePending: 'In de wachtrij (e-mail/WhatsApp)',
      queueIndeedWaiting: 'Indeed, nog niet geclaimd',
      queueExtensionQueued: 'Geclaimd door een browser',
      queueInProgress: 'Bezig',
      queueCompleted24h: 'Afgerond in 24u',
      queueFailed24h: 'Mislukt in 24u',
      oldestClaim: (when) => `oudste claim ${when}`,
      lastIndeedActivity: (when) => `Laatste Indeed-activiteit ${when}`,
      noIndeedActivity: 'Nog geen Indeed-activiteit',
      browsers: 'Browsers die deze zoekopdracht rapporteren',
      browsersEmpty: 'Geen browser rapporteert deze zoekopdracht.',
      openQueue: 'Wachtrij van deze zoekopdracht',
      openOwnerIntervals: 'Intervallen van de eigenaar',
    },
    install: {
      indeedOn: 'Indeed aan',
      indeedOff: 'Indeed uit',
      project: (name) => `Project ${name}`,
      projectNotPicked: 'Geen project gekozen',
      projectMissing: (name) =>
        name ? `Project ${name} bestaat niet meer in Indeed` : 'Project bestaat niet meer in Indeed',
      projectUnchecked: 'project niet gecontroleerd in de laatste cyclus',
      gate: (gate) => `Gate: ${gate}`,
      sessionValid: 'Indeed-sessie geldig',
      sessionInvalid: 'Indeed-sessie ongeldig',
      sessionUnknown: 'Indeed-sessie niet gecontroleerd',
      credits: (credits) => `${credits} contactcredits`,
      creditsUnlimited: 'Onbeperkt contactcredits',
      creditsUnknown: 'Contactcredits onbekend',
      stalledSince: (when) => `Staat stil sinds ${when}`,
      advertiserKey: (key) => `Advertiser ${key}`,
      lastSeen: (when) => `Gezien ${when}`,
      version: (version) => `v${version}`,
      queue: 'Wachtrij',
      intervals: 'Intervallen',
    },
    installs: {
      columns: {
        recruiter: 'Recruiter',
        indeed: 'Indeed',
        version: 'Versie',
        lastSeen: 'Laatst gezien',
        advertiserKey: 'Advertiser key',
        intervals: 'Intervallen in gebruik',
        config: 'Config',
        outreachGate: 'Laatste outreach-gate',
        actions: 'Openen',
      },
      connection: {
        connected: 'Gekoppeld',
        disconnected: 'Niet gekoppeld',
        unknown: 'Niet gecontroleerd',
        no_report: 'Nog geen rapport',
      },
      intervalsCell: (messageMinutes, outreachMinutes) =>
        `Berichten ${messageMinutes ?? '–'} min · outreach ${outreachMinutes ?? '–'} min`,
      config: {
        applied: (version) => `Toegepast (v${version})`,
        pending: (applied, latest) => `Wacht: op v${applied ?? '–'}, nieuwste v${latest}`,
        no_override: 'Standaard',
        unknown: (applied) => `Op v${applied ?? '–'}`,
      },
      reported: (when) => `gerapporteerd ${when}`,
      nextCycle: (when) => `volgende ronde ${when}`,
      nextCycleDue: 'volgende ronde nu verwacht',
      nextCycleOverdue: (when) => `volgende ronde was ${when} verwacht`,
      noOutreachReport: 'Geen outreach-rapport',
      empty: 'Nog geen browser heeft gerapporteerd.',
    },
    queue: {
      scopeSearch: (label) => `Zoekopdracht: ${label}`,
      scopeRecruiter: (label) => `Recruiter: ${label}`,
      scopeInstall: (installId) => `Browser: ${installId}`,
      scopeAdvertiser: (key) => `Advertiser key: ${key}`,
      noScope:
        'De wachtrij heeft een bereik nodig. Open hem vanuit een zoekopdracht of een browser, kies een recruiter, of vul een advertiser key in.',
      clearScope: 'Bereik wijzigen',
      status: 'Status',
      statusAll: 'Alle Indeed-statussen',
      columns: {
        score: 'Score',
        candidate: 'Kandidaat',
        search: 'Zoekopdracht',
        status: 'Status',
        attempts: 'Pogingen',
        created: 'Aangemaakt',
        updated: 'Bijgewerkt',
      },
      orderNote: 'Hoogste score eerst.',
      empty: 'Niemand wacht in dit bereik.',
    },
    intervals: {
      pickRecruiter: 'Kies een recruiter om te wijzigen hoe vaak zijn extensie de Indeed-alarmen draait.',
      title: (name) => `Indeed-alarmintervallen van ${name}`,
      message: 'Interval berichten ophalen (minuten)',
      outreach: 'Interval outreach-wachtrij (minuten)',
      help: (min, max, defaultMinutes) => `${min} tot ${max}. Laat leeg voor de standaard, ${defaultMinutes}.`,
      expiresAt: 'Verloopt op',
      noExpiry: 'Verloopt niet',
      noExpiryHelp: 'De aanpassing blijft staan tot iemand hem wijzigt.',
      save: 'Opslaan',
      reset: 'Terug naar standaard',
      saved: 'Intervallen opgeslagen.',
      resetDone: 'Intervallen teruggezet naar de standaard.',
      saveFailed: 'Kon de intervallen niet opslaan.',
      errors: {
        not_integer: 'Alleen hele minuten.',
        below_min: (min) => `Minstens ${min}.`,
        above_max: (max) => `Hoogstens ${max}.`,
        expiry_missing: 'Kies een datum en tijd, of vink "Verloopt niet" aan.',
        expiry_invalid: 'Dit is geen geldige datum en tijd.',
        expiry_past: 'Moet in de toekomst liggen.',
      },
      statusNone: 'Geen aanpassing. De extensie gebruikt de standaardwaarden.',
      statusActive: (version) => `Aanpassing actief (versie ${version}).`,
      statusExpired: (version) =>
        `Aanpassing verlopen (versie ${version}). De extensie gebruikt weer de standaardwaarden.`,
      expiresOn: (when) => `Verloopt ${when}.`,
      neverExpires: 'Verloopt nooit.',
      updatedBy: (name, when) => `Laatst gewijzigd door ${name}, ${when}.`,
      jitterNote: 'Je stelt het gemiddelde in. De extensie voegt nog steeds ±35% spreiding toe aan elk alarm.',
      applyNote: 'Een browser neemt een wijziging over bij zijn volgende statusrapport.',
      browsers: 'Browsers',
      browsersEmpty: 'Deze recruiter heeft nog geen browser die rapporteerde.',
      browserApplied: (version) => `Gebruikt versie ${version}`,
      browserPending: (applied, latest) => `Nog op versie ${applied ?? '–'}, nieuwste is ${latest}`,
      browserNoOverride: 'Gebruikt de standaardwaarden',
    },
  },
};
